import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, EventEmitter, asNativeElements, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { MenuService } from '../../../app/menu.service';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import  moment from 'moment-timezone';
import {  NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { NgbCalendar, NgbCalendarGregorian } from '@ng-bootstrap/ng-bootstrap'
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';

import { MatPaginator } from '@angular/material/paginator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { powerTrain } from '../device-reports/device-reports.models';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { EboilerDashboardComponent } from '../../eBoiler/eboiler-dashboard/eboiler-dashboard.component';
import { BoilerRoomComponent } from '../../eBoiler/boiler-room/boiler-room.component';
import { OvenDashboardComponent } from '../../oven-system/oven-dashboard/oven-dashboard.component';
import { OvenDeviceListComponent } from '../../oven-system/oven-device-list/oven-device-list.component';
import { TransformersComponent } from '../transformers/transformers.component';
import { EnergymeterMapComponent } from '../../admin/energymeter-map/energymeter-map.component';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { GaugeMonitoringDashboardComponent } from "../gauge-monitoring-dashboard/gauge-monitoring-dashboard.component";
import { CyclinderListingsComponent } from '../../cyclinders/cyclinder-listings/cyclinder-listings.component';

interface Sensor {
  x: number;
  y: number;
  subType: string;
  assetType: string;
  associated: boolean;
  configured: boolean;
  gateway_id: number;
  no_of_axis: number;
  assetMarker: string;
  xPercentage: number;
  yPercentage: number;
  sensorDNames: string;
  sensorMarker: string;
  sensors_info: any;
  xPercentages: number;
  yPercentages: number;
  sensor_number: number;
  xPercentageNet: number;
  yPercentageNet: number;
  form_configured: boolean;
  temperature_channel: number;
  is_temperature_added: number;
  color?: string;
  asset_status?: number;
  health:string,
  device_status:number,
  master_type:number
  mac_address:string,
  serial_number:string,
}

interface Asset {
  id: number;
  subsystem_uuid: string;
  template_id: number | null;
  subsystem_type: string;
  subsystem_name: string;
  site_id: number | null;
  application_id: number | null;
  client_id: number;
  Image_path: string;
  device_position: string;
  created_at: string;
  updated_at: string;
  out_for_service: number;
  display_order: number | null;
  commission_date: string | null;
  axis: number | null;
  sensors?: Sensor[];
  overall_health?: string;
  overall_live_status?: number;
}

@Component({
  selector: 'app-device-reports-copy',
  templateUrl: './device-reports-copy.component.html',
  styleUrls: ['./device-reports-copy.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatTooltip, MatButtonModule, MatTooltipModule, MatSlideToggleModule, MatPaginator, FormsModule, NgbModule, NgbNavModule, MatMenu, MatMenuModule, MatIcon, BoilerRoomComponent, OvenDeviceListComponent, TransformersComponent, EnergymeterMapComponent, MatTooltipModule, MatTooltip, GaugeMonitoringDashboardComponent,CyclinderListingsComponent],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}],
})
export class DeviceReportsCopyComponent implements OnInit {
  private updateRebootStatus = BaseUrlConstantsService.UPDATE_ASSETS;
  private baseURL = BaseUrlConstantsService.BASE_MIDDLEWARE_SELF;
  private allSitesUrl = BaseUrlConstantsService.GET_SITES;
  private getApplicationsUrl = BaseUrlConstantsService.GET_APPLICATION;
  public sensorData = BaseUrlConstantsService.Sensor_Data;
  public assetsListUrl = BaseUrlConstantsService.ASSETS_LIST;
  public assetsUrl = BaseUrlConstantsService.ASSETS_DATA;
  private assetDeleteUrl = BaseUrlConstantsService.DELETE_ASSETS;
  public clientDeviceUrl = BaseUrlConstantsService.CLIENT_DEVICES;
  public assetServiceUrl = BaseUrlConstantsService.BASE_ASSET_SERVICE;
  public assetsUrlEdit = BaseUrlConstantsService.ASSETS_DATA_EDIT;
  public deviceStatusURL = BaseUrlConstantsService.INVENTORY_URL;
  public production = BaseUrlConstantsService.PRODUCTION_KEY;
  public productApi = BaseUrlConstantsService.PRODUCT_LIST_API;
  public getRotatingAssets = BaseUrlConstantsService.ROTATING_TAB_SERVICE;
  //public locAssetsListUrl =BaseUrlConstantsService.LOC_ASSETS_LIST;
  public QAkey = BaseUrlConstantsService.QA_KEY;
  public loading:boolean=true;

  //tab 3 start.
    private EnergymeterBaseUrl = BaseUrlConstantsService.energyMeterApi;

    //YTD Cost Functionality Variable.
    public YTDCost: any = {};
    public YTDCarbonFootprintCost: any = {};
    public PFCost: any = {};

    public mainScreenYTDCost: any = {};
    public mainScreenYTDCarbonFootprintCost: any = {};
    public mainScreenPFCost: any = {};
    public mainScreenPDCost: any = {};


    //Energymeter Start.
    public energymeterListings: any = [];
    public EnergymetersiteFilterValue: any = [];
    public EnergymeterApplicationFilterValue: any = [];
    public EnergymeterSingleFilterValue: any = [];
    public EnergymeterAllDeviceSecondArray: any = [];
    public EnergymetergroupList: any = [];
    public dataEnergymeter: any;
    public siteid:number =0;
    public applicationid:number =0;
    public emSerialNumber:any =0;

    public energymeterSitesList: any = [];
    public energymeterApplicationList: any = [];
    public loadingService:boolean = true;

    //Delete EM.
    public subsystemID:number=0;
    public clientEmRelationID:number=0;

    //Map Array.
    public allAddresses:any = [];
    public allPointer:any = [];
    public allPointerFilterData:any = [];

    //Energymeter radio button on first screen.
    public selectedRange: string;

    //Energymeter Start.

  //tab 3 end.


  public myDate: Date;
  public today: any;
  public extendedChildList: any = []
  public allDevices: any = [];
  public allDevicesFilter: any = [];
  public clientId: any;
  public mInterval: any;
  public siteFilterValue: any = [];
  public groupFilterValue: any = [];
  public fromDate: NgbDate;
  public toDate: NgbDate;
  public totalSize = 100;
  public timer: number = 5000;
  public siteList: any = [];
  public groupList: any = [];
  public devices: any = [];
  public searchText: any;
  public mac_address : any;
  public allDeviceSecondArray: any = [];
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public emptyMsgSHOW: string;
  public checked = false;
  public assetList: any = [];
  public assets: any = [];
  public term: any;
  public showFilter = false;
  public selectValueArr = [];
  public assetsAll: any = [];
  public arrListAssets: any;
  public gridLayoutOn = true;
  public listLayoutOn: boolean;
  public chartBoxVisibility: boolean;
  public sensorDataArr = [];
  public onoffStatus: number = 0;
  public selectedSite: string = "All Sites";
  public assetsFilter: any="ALL";
  public breadcrumbsArray: any = [{
    page_ref: '/device-report-new',
    page_title: 'Assets'
  }];
  public filterList = [{
    title: 'All Assets',
    value: '1'
  }, {
    title: 'ERROR',
    value: '1'
  }, {
    title: 'HEALTHY',
    value: '1'
  }, {
    title: 'UNASSOCIATED',
    value: '1'
  }, {
    title: 'OFFLINE',
    value: '1'
  }];
  public showEmptyError = 'Fetching assets, please wait..';
  public sitesList: any = [];
  public check = 0;
  public objBread: any;
  public pageName: string;
  public _lastUpdate: any;
  public isDisabled: boolean;
  public userRoll: any;
  public _timeOut: any;
  public hideItemsFromAssets = false;
  public clientName: string;
  public adminClinetLogin: boolean;
  public eventHoverOnCard: any;
  public intervalVar: any;
  public devicedata: any;
  public _driveTemps: any = [];
  public _rmsAccels: any = [];
  public mouseenter: boolean;
  public hidePopover: boolean;
  public mouseleave: boolean;
  public _greenRmsIcon: boolean = false;
  public _yellowRmsIcon: boolean = false;
  public _redRmsIcon: boolean = false;
  public shouldShow: boolean;
  public checkClass: string;
  public company_name: string;
  public userID: any;
    //For Paginantion
    public array: any;
    public displayedColumns = ["", "", "", "", ""];
    public dataSource: any;

    public tabActice = 'tab-1';
    public showEmeter:boolean=false;
    public showStat: boolean = true;
    public currentPage = 1;


    @ViewChild(MatPaginator) paginator: MatPaginator;


    offset: number=0;
    public randomWidths:number[] = [];
    public tempPageSize: number = 25;
    public pageSize: any = this.tempPageSize;
    // public pageSize:any=100;
    public limit: any=this.pageSize;
    public pageIndex:any=0;
    public tabID_1: boolean = true;
    public tabID_2: boolean = false;
    public tabID_3: boolean = false;
    public tabID_4: boolean = false;
    public tabID_5: boolean = false;
    public tabID_6: boolean = false;
    public tabID_7: boolean = false;
    public tabID_8: boolean = false;
    public legendKey: boolean = true;
    public totalNumberRotatingDevice: any = 0;
    public eboilerCount: any = -0;
    public energymeterCount: any = 0;
    public transformerCount: any = 0;

    public loadMainScreen:boolean = false;
    public meterViewloader=false;
    public paramsObject:any
    public isOnline: boolean = false; // Set dynamically based on actual online/offline status
    public rotatingAssetLoader: boolean = true;
    public rotatingAssetExists: boolean = false;
    public water_management_count: number = 0;
    public oven_system_count: number = 0;
    public cylindersCount: any = 0;
  generic_asset_id: any;

  constructor(

    public calendar: NgbCalendar,
    public router: Router,
    public menuService: MenuService,
    public activeRoute: ActivatedRoute,
    private changeService: ChangeUsersService,
    public dialog: MatDialog,

    private service: BackendApiService) {
    localStorage.removeItem("chart_one_data");
    localStorage.removeItem("chart_two_data");
    localStorage.removeItem("chart_three_data");

    activeRoute.queryParams.subscribe((params) => {
      this.paramsObject = params;
      if(this.tabActice === 'tab-1'){
        this.onTabChange({nextId: 'tab-1'});
        this.tabID_1 = true;
        this.tabID_2 = params['tab2'];
        this.tabID_3 = params['tab3'];
        this.tabID_4 = params['tab2'];
      }
      this.tabActice = params[`tabName`];
      if(this.tabActice === 'tab-3'){
        this.onTabChange({nextId: 'tab-3'});
        this.tabID_1 = true;
        this.tabID_2 = params['tab2'];
        this.tabID_3 = true;
        this.tabID_4 = params['tab4']=='false'?false:true;
        this.showStat=params['toggle'];
        this.showEmptyError=""
        this.onToggleChange({checked:params['toggle']=='false'?false:true});
      }
      if(this.tabActice === 'tab-2'){
        this.onTabChange({nextId: 'tab-2'});
        this.tabID_1 = true;
        this.tabID_2 = true;
        this.tabID_3 = params['tab3'];
        this.tabID_4 = params['tab4'];
      }
      if(this.tabActice === 'tab-4'){
        this.onTabChange({nextId: 'tab-4'});
        this.tabID_1 = true;
        this.tabID_2 = false;
        this.tabID_3 = false;
        this.tabID_4 = true;
      }
      if(this.tabActice === 'tab-6'){
        this.onTabChange({nextId: 'tab-6'});
        this.tabID_1 = true;
        this.tabID_2 = false;
        this.tabID_3 = false;
        this.tabID_4 = false;
        this.tabID_6 = true;
      }
      if(this.tabActice === 'tab-5'){
        this.onTabChange({nextId: 'tab-5'});
        this.tabID_1 = true;
        this.tabID_2 = false;
        this.tabID_3 = false;
        this.tabID_4 = false;
        this.tabID_5 = true;
        this.tabID_7 = false;
      }


      });

    if (localStorage.getItem('role') === 'ACCOUNT_MANAGER') {
      this.userID = localStorage.getItem('admin_client_id');
    } else if (localStorage.getItem('role') === 'USER') {
      this.userID = localStorage.getItem('associated_clientid');
    } else if (localStorage.getItem('role') === 'ADMIN') {
      this.userID = localStorage.getItem('admin_client_id');
    }
    else if (localStorage.getItem('role') === 'OEM') {
      this.userID = localStorage.getItem('admin_client_id');
    }else {
      this.userID = localStorage.getItem('user_id');
    }

    if (this.userRoll === "USER") {
      this.clientId = localStorage.getItem("user_id");
    } else {
      this.clientId = localStorage.getItem("admin_client_id") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("admin_client_id");
    }

    this.utcTime();

    this.userRoll = localStorage.getItem('role');

    if (this.userRoll === 'USER') {
      this.hideItemsFromAssets = false;
    } else {
      this.hideItemsFromAssets = true;
    }

    if (localStorage.getItem('admin_client_id') === 'null') {
      this.adminClinetLogin = true;
    } else {
      this.clientName = localStorage.getItem('admin_client_name');
      this.adminClinetLogin = false;
    }

    menuService.getItemFromMenu.subscribe(result => this.searchByMenuiD(result));

    activeRoute.queryParams.subscribe((params) => {

      this.tabActice = params[`tabName`];
      this.showEmeter = params[`showEmeter`];
      if(this.showEmeter == true){

        this.siteid= parseInt(params[`site_id`]);
        this.showStat= params[`showStat`];
        if(this.siteid > 0){

          this.getEnergymeterAllSitesByID(this.siteid);
          setTimeout(() => {
            this.applicationid= parseInt(params[`application_id`]);
            if(this.applicationid > 0){
              this.getEnergymeterAllApplicationsByID(this.applicationid);
            }
          }, 1000);

        }

      }
      if(this.tabActice === 'tab-2'){
        this.legendKey = false;
      }else{
        this.legendKey=true;
      }
      this.pageName = params[`pageRef`];
      // console.log("first")
      if(this.pageName === 'boiler-room'){
        const myObj = {
          page_ref: 'clients',
          page_title: 'clients'
        };
        this.breadcrumbsArray.unshift(myObj);
        this.company_name = localStorage.getItem('company_name');
      }
      if(this.pageName === 'admin-emeter'){
        const myObj = {
          page_ref: 'clients',
          page_title: 'clients'
        };
        this.breadcrumbsArray.unshift(myObj);
        this.company_name = localStorage.getItem('company_name');
      }
      if(this.pageName === "" && localStorage.getItem('role') === "ADMIN"){
        const myObj = {
          page_ref: 'clients',
          page_title: 'clients'
        };
        this.clientId = localStorage.getItem('admin_client_id');
        this.company_name = localStorage.getItem('company_name');
        this.breadcrumbsArray.unshift(myObj);
      }
      if(this.pageName === "" && localStorage.getItem('role') === "OEM"){
        const myObj = {
          page_ref: 'OEM-Client',
          page_title: 'clients'
        };
        this.company_name = localStorage.getItem('company_name');
        this.breadcrumbsArray.unshift(myObj);
      }
      if (this.pageName === 'managerAssets') {
        const myObj = {
          page_ref: 'manager-client-list',
          page_title: 'manager clients'
        };
        localStorage.setItem('company_name', params[`clientName`]);
        this.company_name = localStorage.getItem('company_name');
        this.breadcrumbsArray.unshift(myObj);
        localStorage.setItem("admin_client_id", params[`admin_client_id`]);
        if (localStorage.getItem('admin_client_id') === 'null') {
          this.adminClinetLogin = true;
        } else {
          localStorage.setItem('admin_client_name', params[`clientName`]);
          this.clientName = params[`clientName`];
          this.adminClinetLogin = false;
        }
      }

      if (this.pageName === 'AdminClientPage' || this.pageName === 'leafletMap') {
        const myObj = {
          page_ref: 'clients',
          page_title: 'clients'
        };

        localStorage.setItem('company_name', params[`clientName`]);
        this.company_name = localStorage.getItem('company_name');
        this.breadcrumbsArray.unshift(myObj);
        localStorage.setItem("admin_client_id", params[`admin_client_id`]);
        if (localStorage.getItem('admin_client_id') === 'null') {
          this.adminClinetLogin = true;
        }
         else {
          localStorage.setItem('admin_client_name', params[`clientName`]);
          this.clientName = params[`clientName`];
          this.adminClinetLogin = false;
          localStorage.setItem('company_name', params[`clientName`]);
          this.company_name = localStorage.getItem('company_name');
          this.assetsFilter=params['assetsFilterName'];
          this.userID=params['admin_client_id'];
        }

      }
      if (this.pageName === 'OEMClientPage') {
        const myObj = {
          page_ref: 'OEM-Client',
          page_title: 'Clients'
        };
        localStorage.setItem('company_name', params[`clientName`]);
        this.company_name = localStorage.getItem('company_name');
        this.breadcrumbsArray.unshift(myObj);
        localStorage.setItem("admin_client_id", params[`admin_client_id`]);
        if (localStorage.getItem('admin_client_id') === 'null') {
          this.adminClinetLogin = true;
        }
         else {
          localStorage.setItem('admin_client_name', params[`clientName`]);
          this.clientName = params[`clientName`];
          this.adminClinetLogin = false;
          localStorage.setItem('company_name', params[`clientName`]);
          this.company_name = localStorage.getItem('company_name');
          this.assetsFilter=params['assetsFilterName'];
          this.userID=localStorage.getItem('admin_client_id');
        }

      }
    });

    if(this.tabID_3===true){
      this.loadingService=true;
      if (this.energymeterListings && this.energymeterListings.length > 0) {
          this.onEnergymeterSiteSelected(0);
      }else{
        this.loadMainScreen = true;
        this.getEnergymeterAllSites(this.clientId);
        this.energyMeterListing(this.clientId,0,0,0);
      }
    }

    this.selectedRange = 'year';
  }

  onToggleChange(event): void {

    this.showStat = event.checked;

    if(this.showStat==false){

      this.tabActice = 'tab-3';
      const navigationExtras = {
        skipLocationChange: true,
        queryParams: {
          tabName : 'tab-3',
          tab1:this.tabID_1,
          tab2:this.tabID_2,
          tab4:this.tabID_4,
          toggle:false
        },
      };

      this.router.navigate(['/device-report-new'],navigationExtras);
      this.getEnergymeterAllSitesByID(0);
    }
  }

  getProductCount() {
    // console.log("Params Object:", this.paramsObject);

    // Check if `tabName` exists and assign it if available
    if (this.paramsObject["tabName"] !== undefined) {
      // console.log("tabName exists:", this.paramsObject["tabName"]);
      // console.log(this.paramsObject["tabName"])
      this.tabActice = this.paramsObject["tabName"];
      // console.log(this.tabActice)
      this.tabID_1 = true;
      this.tabID_2 = this.paramsObject["tab2"] === "true" ? true : false;
      this.tabID_3 = this.paramsObject["tab3"] === "true" ? true : false;
      this.tabID_4 = this.paramsObject["tab4"] === "true" ? true : false;
    } else {
      // console.log("tabName is undefined; setting default.");
      this.tabActice = "tab-1"; // Default tab if `tabName` is missing
      this.tabID_1 = true;
      this.tabID_2 = this.paramsObject["tab2"] === "true" ? true : false;
      this.tabID_3 = this.paramsObject["tab3"] === "true" ? true : false;
      this.tabID_4 = this.paramsObject["tab4"] === "true" ? true : false;
    }

    // Check if counts are missing
    const countsMissing =
      this.paramsObject["roatingassets"] === undefined ||
      this.paramsObject["eboilerCount"] === undefined ||
      this.paramsObject["transformerCount"] === undefined ||
      this.paramsObject["energymeterCount"] === undefined;

    if (!countsMissing) {
      // If all counts exist, assign them directly
      // console.log("All counts are available; no need for API call.");
      this.tabID_1 = true;
      this.tabID_2 = this.paramsObject["tab2"] === "true" ? true : false;
      this.tabID_3 = this.paramsObject["tab3"] === "true" ? true : false;
      this.tabID_4 = this.paramsObject["tab4"] === "true" ? true : false;
      this.totalNumberRotatingDevice = this.paramsObject["roatingassets"];
      this.eboilerCount = this.paramsObject["eboilerCount"];
      this.transformerCount = this.paramsObject["transformerCount"];
      this.energymeterCount = this.paramsObject["energymeterCount"];
    } else {
      // If counts are missing, make the API call
      // console.log("Counts missing; making API call.");
      this.service
        .getData(
          this.productApi +
            "/" +
            Math.floor(Math.random() * 90 + 10) +
            this.userID +
            Math.floor(Math.random() * 9000 + 1000)
        )
        .then((res) => {
          const response = JSON.parse(JSON.stringify(res)).data;
          // console.log("API response received.");

          if (response.status === "success" && response.body.body.length > 0) {
            // console.log("Populating counts from API response.");
            response.body.body.forEach((item) => {
              let count = item.count;

              // Update counts based on the subsystem type
              switch (item.subsystem_type) {
                case "RotatingAsset":
                  this.totalNumberRotatingDevice = count;
                  this.tabID_1 = true;
                  break;

                case "custom-TBoiler":
                  this.eboilerCount = count;
                  this.tabID_4 = true;
                  break;

                case "transformer":
                  this.transformerCount = count;
                  this.tabID_2 = true;
                  break;

                case "emeter":
                  this.energymeterCount = count;
                  this.tabID_3 = true;
                 this.loadMainScreen = true;
                  break;
                case "Water Management":
                  this.water_management_count = count;
                  this.tabID_6= true;
                  break;
                case "custom-oven":
                  this.oven_system_count = count;
                  this.tabID_7= true;
                  break;
                case "Cylinders":
                  this.cylindersCount = count;
                  this.tabID_5= true;
                  break;

              }
              // console.log(this.tabID_1, this.tabID_2, this.tabID_3, this.tabID_4)
            });
            if(this.totalNumberRotatingDevice == 0 && this.pageName != "oven-device-list"){
              if(this.eboilerCount > 0 && this.tabID_4 == true){
             this.tabActice='tab-4';
              }else if(this.energymeterCount > 0 && this.tabID_3 == true){
                  this.tabActice='tab-3';
                  this.getEnergymeterAllSites(this.clientId);
                  this.energyMeterListing(this.clientId,0,0,0);
              }
             }
             if(this.clientId == 388 && this.userID == 388 ){
              this.tabID_8 = true;
             }
          } else {
            console.log("No valid data received from API.");
            // this.setDefaultCounts();
          }
          this.generateRandomWidths(this.totalNumberRotatingDevice)
          this.loadAllDevices()
        })
        .catch((error) => {
          console.error("Error fetching data from API:", error);
          this.setDefaultCounts();
        });
    }
  }

  // Helper method to set default counts when no data is available
  setDefaultCounts() {
    // console.log("Setting default counts.");
    this.tabID_1 = true;
    this.tabID_2 = false;
    this.tabID_3 = false;
    this.tabID_4 = false;
    this.tabActice = "tab-1";
  }
buildUrl(
    baseUrl: string,
    siteId?: string | null,
    id?: string | null
  ): string {
    const params: string[] = [];

    // Helper to test “real” values
    const isValid = (v: string | null | undefined) =>
      v !== undefined && v !== null && v !== "null";

    if (isValid(siteId)) {
      params.push(`siteFilter=${encodeURIComponent(siteId as string)}`);
    }
    if (isValid(id)) {
      params.push(`id=${encodeURIComponent(id as string)}`);
    }

    // If we collected any valid params, join them with & and prepend “?”
    const queryString = params.length ? `&${params.join("&")}` : "";

    return `${baseUrl}${queryString}`;
  }

// Helper function to activate the tab based on the service data
activateTabBasedOnServiceData() {
  const OldActiveTab = localStorage.getItem('activeTabIndex');
    if (OldActiveTab === "tab-1") {
        this.activeRoute.queryParams.subscribe((params) => {

                this.onTabChange({nextId: 'tab-1'});
                this.tabActice = 'tab-1';

        });
    } else if (OldActiveTab === "tab-2") {
        this.activeRoute.queryParams.subscribe((params) => {

                this.onTabChange({nextId: 'tab-2'});
                this.tabActice = 'tab-2';

        });
    } else if (OldActiveTab === "tab-3") {
        this.activeRoute.queryParams.subscribe((params) => {

                this.onTabChange({nextId: 'tab-3'});
                this.tabActice = "tab-3";

        });
    } else if (OldActiveTab === "tab-4") {
        this.activeRoute.queryParams.subscribe((params) => {

                this.onTabChange({nextId: 'tab-4'});
                this.tabActice = 'tab-4';

        });
    }
}

  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
   //For DSP
  //  this.today=new Date();
      const time = date + ':' + houre + ':' + second;
      this.myDate = JSON.parse(JSON.stringify(time));
    }, 1000);
  }
  async openDetailScreen(sensorData: any, allChild: any) {

    localStorage.setItem('MacAddress', sensorData.mac_address);
    localStorage.setItem('SiteName', allChild.site.name);
    localStorage.setItem('SiteName', allChild.site.name);
    localStorage.setItem('ApplicationName', allChild.application.name);
    // const currentAsset=this.allDeviceSecondArray.filter(asset=>asset.id==sensorData.id);
    const assetChilds = allChild.connected_sensors.filter(x => { return x.device_sno != 1 });
    //this.pageName="SuperAdminpage"
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: this.pageName,
        deviceId: sensorData.inventory_id,
        assetid: sensorData.id,
        label: sensorData.lbl,
        asset_type: sensorData.asset_type,
        sub_type: allChild.sub_type,
        device_serial_no: sensorData.device_sno,
        serial_no: sensorData.sno,
        assetStatus: sensorData.asset_status,
        overallStatus: allChild.overall_status,
        sensorType: sensorData.sensor,
        no_of_children: assetChilds.length,
        asset_master_info: JSON.stringify(allChild),
        macaddress: sensorData.mac_address,
        kurt_freq: allChild.kurt_freq,
        kurt_threshold: allChild.kurt_threshold,
        kurt_anomaly_counter: allChild.kurt_anomaly_counter,
        route_path: "device-report-new",
        parentData: sensorData.parent == "primary" ? null : JSON.stringify({ ...allChild.connected_sensors[0] }),
        outOfService: allChild.out_of_service,
        motor_serial_no: sensorData.motor_serial_no,
        tabName:this.tabActice,
        tab2: this.tabID_2,
        tab3: this.tabID_3,
        tab4: this.tabID_4,
        master_type:sensorData.master_type,
      },
    };

    // setTimeout(() => {
    //   localStorage.setItem('Monitoring_window',"false");
    // }, 1000);

    //  localStorage.setItem('Monitoring_window',"true");
    localStorage.setItem('tab', 'tab-1');

    // console.log(this.userID, this.clientId)



    if (!navigationExtras.queryParams || Object.keys(navigationExtras.queryParams).length === 0) {
      console.warn('NavigationExtras queryParams is empty. Not opening a new window.');
      return;
    }
    // this.userID === "390" || this.clientId === "390"
    if (this.userID == '390' || this.clientId == '390') {
      const flags = new URLSearchParams({
        Monitoring_window: 'true'
      }).toString();

      const windowName = `detailWindow-${Date.now()}`;
      const childWin = window.open(`/#/detail-nxt?${flags}`, windowName);

      if (!childWin) {
        console.error('Popup blocked');
        return;
      }

      const onReady = (e: MessageEvent) => {
        if (e.origin === window.location.origin && e.data?.type === 'ready') {
          childWin.postMessage(
            { type: 'init', payload: { data: navigationExtras } },
            window.location.origin
          );
          window.removeEventListener('message', onReady);
        }
      };

      window.addEventListener('message', onReady, false);
    }  else {

      this.router.navigate(["detail-nxt"], navigationExtras);

    }


  }



  async goToDetailScreen(assetObj: any) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : '',
        deviceId: assetObj.inventory_id,
        assetid: assetObj.id,
        assetStatus: assetObj.asset_status,
        asset_type: assetObj.asset_type
      }
    };
    this.router.navigate(['detail-nxt'], navigationExtras);
  }

  sensorApiMethod(inventoryID, assetID) { }

  toggleWithMouse(popover, inventoryID: any, assetId: any, idx: number) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      this.hidePopover = false;
      this.service.getDataWithQuery(this.sensorData + "/" + inventoryID + "/" + assetId + "?userid=" + this.userID).then(async res => {
        this.hidePopover = false;
        let response = JSON.parse(JSON.stringify(res)).data;
        if (response.status === 'fail') {
          const msgErr = response.body.message;
          this.service.showError(msgErr);
        } else if (response.status === 'success') {
          if (response.body.length !== 0) {
            if (response.body.sensor.length !== 0) {
              this.sensorDataArr = [];
              var testDateUtc = moment.utc(response.body.issue.lastupdate);
              var localDate = testDateUtc.local();
              this._lastUpdate = new ConvertDatetimePipe().convertDateTime(localDate);
              this._rmsAccels = [];
              this._driveTemps = [];
              for (let va = 0; va < response.body.sensor.length; va++) {
                if ((response.body.sensor[va].value < 0 && response.body.sensor[va].key !== 'OrientationX') &&
                  (response.body.sensor[va].value < 0 && response.body.sensor[va].key !== 'OrientationY') &&
                  (response.body.sensor[va].value < 0 && response.body.sensor[va].key !== 'OrientationZ')) {
                  response.body.sensor[va].value = 'N/A';
                }
                if (response.body.sensor[va].key.includes('RMS_Accel_1_X_Axis')) {
                  this.sensorDataArr.splice(0, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes('RMS_Accel_1_Y_Axis')) {
                  this.sensorDataArr.splice(1, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes('RMS_Accel_1_Z_Axis')) {
                  this.sensorDataArr.splice(2, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes('Winding_Temperature')) {
                  this.sensorDataArr.splice(3, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes('Ambient_Temperature')) {
                  this.sensorDataArr.splice(4, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes('Bearing_Temperature')) {
                  this.sensorDataArr.splice(5, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes('Rate of change of useful life left')) {
                  this.sensorDataArr.splice(6, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes('OrientationX')) {
                  this.sensorDataArr.splice(7, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes('OrientationY')) {
                  this.sensorDataArr.splice(8, 0, response.body.sensor[va]);
                }
                if (response.body.sensor[va].key.includes('OrientationZ')) {
                  this.sensorDataArr.splice(9, 0, response.body.sensor[va]);
                }
              }
              this.devicedata = response.body.message === 'No results found' ? [] : this.sensorDataArr
              for (var i = 0; i < this.devicedata.length; i++) {
                if (this.devicedata[i].key === 'Bearing_Temperature'
                  || this.devicedata[i].key === 'Winding_Temperature'
                  || this.devicedata[i].key === 'Ambient_Temperature') {
                  this._driveTemps.push(this.devicedata[i]);
                  this.hidePopover = true;
                }
                if (this.devicedata[i].key === 'RMS_Accel_1_X_Axis'
                  || this.devicedata[i].key === 'RMS_Accel_1_Y_Axis'
                  || this.devicedata[i].key === 'RMS_Accel_1_Z_Axis') {
                  this._rmsAccels.push(this.devicedata[i]);
                  this.hidePopover = true;
                }
              }
              if (((this._rmsAccels[0].value / parseFloat(this._rmsAccels[0].rangelabel[1])) * 100 < this._rmsAccels[0].arcDelimiters[0])
                && ((this._rmsAccels[1].value / parseFloat(this._rmsAccels[1].rangelabel[1])) * 100 < this._rmsAccels[1].arcDelimiters[0])
                && ((this._rmsAccels[2].value / parseFloat(this._rmsAccels[2].rangelabel[1])) * 100 < this._rmsAccels[2].arcDelimiters[0])) {
                this._greenRmsIcon = true;
                this._yellowRmsIcon = false;
                this._redRmsIcon = false;
              }
              if (((this._rmsAccels[0].value / parseFloat(this._rmsAccels[0].rangelabel[1])) * 100 >= this._rmsAccels[0].arcDelimiters[0] && (this._rmsAccels[0].value / parseFloat(this._rmsAccels[0].rangelabel[1])) * 100 < this._rmsAccels[0].arcDelimiters[1])
                || ((this._rmsAccels[1].value / parseFloat(this._rmsAccels[1].rangelabel[1])) * 100 >= this._rmsAccels[1].arcDelimiters[0] && (this._rmsAccels[1].value / parseFloat(this._rmsAccels[1].rangelabel[1])) * 100 < this._rmsAccels[1].arcDelimiters[1])
                || ((this._rmsAccels[2].value / parseFloat(this._rmsAccels[2].rangelabel[1])) * 100 >= this._rmsAccels[2].arcDelimiters[0] && (this._rmsAccels[2].value / parseFloat(this._rmsAccels[2].rangelabel[1])) * 100 < this._rmsAccels[2].arcDelimiters[1])) {
                this._greenRmsIcon = false;
                this._yellowRmsIcon = true;
                this._redRmsIcon = false;
              }
              if (((this._rmsAccels[0].value / parseFloat(this._rmsAccels[0].rangelabel[1])) * 100 >= this._rmsAccels[0].arcDelimiters[1])
                || ((this._rmsAccels[1].value / parseFloat(this._rmsAccels[1].rangelabel[1])) * 100 >= this._rmsAccels[1].arcDelimiters[1])
                || ((this._rmsAccels[2].value / parseFloat(this._rmsAccels[2].rangelabel[1])) * 100 >= this._rmsAccels[2].arcDelimiters[1])) {
                this._greenRmsIcon = false;
                this._yellowRmsIcon = false;
                this._redRmsIcon = true;
              }
            } else {
              this._rmsAccels = [];
              this._driveTemps = [];
              this.hidePopover = false;

            }
          } else {
            this._rmsAccels = [];
            this._driveTemps = [];
            this.hidePopover = false;

          }
        } else {
          this._rmsAccels = [];
          this._driveTemps = [];
          this.hidePopover = false;

        }
      });
    }
  }


  mouseInPopoverList(inventoryID, assetID, idx) {
    this.hidePopover = false;
    this.service.getDataWithQuery(this.sensorData + "/" + inventoryID + "/" + assetID + "?userid=" + localStorage.getItem('role') === 'ADMIN' ? localStorage.getItem('admin_client_id') : this.userID).then(async res => {
      this.hidePopover = false;
      let response = JSON.parse(JSON.stringify(res)).data;
      if (response.status === 'fail') {
        const msgErr = response.body.message;
        this.service.showError(msgErr);
      } else if (response.status === 'success') {
        if (response.body.sensor.length !== 0) {
          this.hidePopover = true;
        } else {
          this._rmsAccels = [];
          this._driveTemps = [];
          this.hidePopover = false;
          this.service.showError("No sensor data available for this asset.");
        }
      } else {
        this._rmsAccels = [];
        this._driveTemps = [];
        this.hidePopover = false;
        this.service.showError("No sensor data available for this asset.");
      }
    });
  }

  mouseOutPopoverList(inventoryID, assetID, idx) {
    this.hidePopover = false;
  }

  menuMoreBtnOpened(index) {
    document.getElementById('menuCl_' + index).classList.add("open");
  }

  menuMoreBtnClose(index) {
    document.getElementById('menuCl_' + index).classList.remove("open");
  }


  listMenuMoreBtnOpened(index) {
    document.getElementById('listMenuCl_' + index).classList.add("open");
  }

  listMenuMoreBtnClose(index) {
    document.getElementById('listMenuCl_' + index).classList.remove("open");
  }

  async mouseInPopover(popover, inventoryID, assetID, idx) {

  }

  mouseOutPopover(popover, inventoryID, assetID, idx) {

  }


  showDeleteDialog(id, inventory_id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: 'auto',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'asset'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteAssets(id, inventory_id, index);
      }
    });
  }



  deleteAssets(id, inventory_id, index) {
    this.service.deleteInfo(this.assetDeleteUrl + "/" + id + "/" + inventory_id).then(res => {
      this.service.deleteInfo(this.assetServiceUrl + "/" + id).then(res2 => {
        if (JSON.parse(JSON.stringify(res)).data.message.includes("successfully deleted")) {
          if (JSON.parse(JSON.stringify(res2)).data.message.includes("Deleted successfully")) {
            this.service.putData(this.deviceStatusURL + "inventory/make/usage/status/" + inventory_id, { "device_status": "FREE" }).then(res2 => {
              this.service.showSuccess('Successfully deleted.');
              this.extendedChildList.splice(index, 1);
              if (this.allDeviceSecondArray.length === 0) {
                this.showList = false;
                this.emptyMsg = true;
              }
            });
          } else {
            this.service.showSuccess('Something went wrong.');
          }
        } else {
          this.service.showSuccess('Something went wrong.');
        }
      });
    });
  }

  async searchByMenuiD(id) {
    if (localStorage.getItem('fromGroup') === 'yes') {
      this.onGroupSelected(id);
    } else {
      this.onSiteSelected(id);
    }
  }

  ngOnInit() {
    // this.generateRandomWidths();
    this.getProductCount();
    this.checkPowertrainStatus()
    localStorage.setItem('_siteId', null);
    localStorage.setItem('_groupId', null);
    localStorage.setItem('_filterVal', null);
    localStorage.setItem('_searchVal', null);
    // localStorage.setItem("ApplicationName", null);
    // localStorage.setItem("SiteName", null);
    // localStorage.setItem("MacAddress", null);
    // localStorage.setItem("AssetSerialNumber", null)
    // localStorage.setItem("ApplicationID", null);
    // localStorage.setItem("siteID", null);
    // this.company_name = localStorage.getItem("company_name");
    if (this.userRoll === 'USER') {
      this.clientId = localStorage.getItem('user_id');
    }
    else if(this.userRoll==='ADMIN'&& localStorage.getItem('admin_client_id')==='undefined') {
            this.clientId=this.userID;
    } else {
      this.clientId = localStorage.getItem('admin_client_id') === 'null' ? localStorage.getItem('user_id') : localStorage.getItem('admin_client_id');
    }

    this.loadAllDevices();
    this.getallSitesAndGroupsInfo(this.clientId);
    // this.getEnergymeterAllSites(this.clientId);

  }
  // onTabChange(event: any) {

  //   this.tabActice=event.nextId;

  //   if(event.nextId === 'tab-2'){
  //     this.legendKey = false;
  //   }else{
  //     this.legendKey=true;
  //   }

  //   if(event.nextId === 'tab-3'){
  //     this.loadingService=true;
  //     this.showStat=false;

  //     if (this.energymeterListings && this.energymeterListings.length > 0) {
  //       this.getEnergymeterAllSitesByID(0);
  //       //this.onEnergymeterSiteSelected(0);
  //     }else{
  //       console.log("Client id on tab change: " + this.clientId)
  //       this.getEnergymeterAllSites(this.clientId);
  //       this.energyMeterListing(this.clientId,0,0,0);
  //       this.loadMainScreen = true;
  //     }


  //   }else{
  //       // this.getEnergymeterAllSites(this.clientId);
  //       // this.energyMeterListing(this.clientId,0,0,0);
  //   }

  // }
   onTabChange(event: any) {
    this.tabActice = event.nextId;
    localStorage.setItem('activeTabIndex', event.nextId);
    if (event.nextId === 'tab-2') {
        this.legendKey = false;
    } else {
        this.legendKey = true;
    }

    if (event.nextId === 'tab-3') {
        this.loadingService = true;
        this.showStat = true;

        if (this.energymeterListings && this.energymeterListings.length > 0) {
            this.getEnergymeterAllSitesByID(0);
            // this.onEnergymeterSiteSelected(0);
        } else {
            if (this.clientId) {
                this.loadMainScreen = true;

                // console.log("Client id on tab change: " + this.clientId);
                this.getEnergymeterAllSites(this.clientId);
                this.energyMeterListing(this.clientId, 0, 0, 0);
            } else {
                console.error(`Client ID is ${this.clientId}. Skipping API call.`);
            }
        }
    } else {
        // Additional logic for other tabs if needed
    }
}

  ngOnDestroy() {
    if (this._timeOut !== undefined) {
      clearInterval(this._timeOut);
    }
  }

  loadAllDevices() {
    if (this._timeOut !== undefined) {
      clearTimeout(this._timeOut);
    }
    for(let i = 0; i <= this.totalNumberRotatingDevice / this.tempPageSize; i ++) {
      this.getallDevices(this.clientId, "device", this.limit);
      this.limit += this.tempPageSize;
      this.pageSize += this.tempPageSize;
    }
    // this.getallDevices(this.clientId, 'device',this.pageSize);
    let self = this;
    self._timeOut = setInterval(function () {
      self.getallDevices(this.clientId, 'interval',this.pageSize);
    }, 30000);
  }

  //YTD COst.
  energyMeterYTDCost(userId,serialnumber){

    this.YTDCost = {};
    this.service.getDataWithQuery(this.EnergymeterBaseUrl+"/energymeter-YTD-cost/"+userId+"/"+serialnumber).then((sRes) => {

      let YTDResponseArray= JSON.parse(JSON.stringify(sRes)).data;
      if (YTDResponseArray.body && Object.keys(YTDResponseArray.body).length !== 0) {

        let response = YTDResponseArray.body;
        if (!this.YTDCost[serialnumber]) {
          this.YTDCost[serialnumber] = {};
        }


        this.YTDCost[serialnumber]['YTDCost'] = response[0].YTD_Cost;
        this.YTDCost[serialnumber]['YTDUnit']= response[0].YTD_Unit;
        this.YTDCost[serialnumber]['YTDCurrency']= response[0].currency;
        this.YTDCost['YTDCurrency']= response[0].currency;

      }

    });
  }

  //YTD Carbon Footprint Cost.
  energyMeterYTDCarbonFootprintCost(userId,generic_asset_id){

    this.YTDCarbonFootprintCost = {};
    this.service.getDataWithQuery(this.EnergymeterBaseUrl+"/energymeter-carbon-footprint-cost/"+userId+"/"+generic_asset_id).then((sRes) => {

      let YTDCarbonFootprintResponseArray= JSON.parse(JSON.stringify(sRes)).data;
      if (YTDCarbonFootprintResponseArray.body && Object.keys(YTDCarbonFootprintResponseArray.body).length !== 0) {

        let response = YTDCarbonFootprintResponseArray.body;
        if (!this.YTDCarbonFootprintCost[generic_asset_id]) {
          this.YTDCarbonFootprintCost[generic_asset_id] = {};
        }


        this.YTDCarbonFootprintCost[generic_asset_id]['YTDCarbonFootprintCost'] = response[0].YTD_Carbon_Footprint_Cost;
        this.YTDCarbonFootprintCost[generic_asset_id]['YTDCarbonFootprintUnit']= response[0].YTD_Carbon_Footprint_Unit;
        this.YTDCarbonFootprintCost[generic_asset_id]['YTDCarbonFootprintCurrency']= response[0].currency;

      }

    });
  }

  //Powerfactor Cost.
  energyMeterPFCost(userId,serialnumber){

    this.PFCost = {};

    this.service.getDataWithQuery(this.EnergymeterBaseUrl+"/energymeter-pf-cost/"+userId+"/"+serialnumber).then((sRes) => {

      let PFResponseArray= JSON.parse(JSON.stringify(sRes)).data;
      if (PFResponseArray.body && Object.keys(PFResponseArray.body).length !== 0) {

        let response = PFResponseArray.body;
        if (!this.PFCost[serialnumber]) {
          this.PFCost[serialnumber] = {};
        }


        this.PFCost[serialnumber]['PFCost'] = response[0].PowerFactor_Cost;


      }

    });
  }
  //Energymeter tab-3 code Start.
  energyMeterListing(userId, siteid, applicationid, generic_asset_id){

    this.EnergymetergroupList=[];
    this.energymeterApplicationList=[];

    this.service.getDataWithQuery(this.EnergymeterBaseUrl+"/energymeter-listings/"+userId+"/"+siteid+"/"+applicationid+"/"+generic_asset_id).then((sRes) => {

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;

        this.energymeterListings =[];

        if (response.result2 != undefined){

          if(response.result2.length != 0){

            this.dataEnergymeter= response.result2;

            if (this.dataEnergymeter.length !== 0) {

              let tempArr = [];
              let bottomLab = "";

              for (let mCount = 0; mCount < this.dataEnergymeter.length; mCount++) {

                let generic_asset_id="";
                let user_id = "";
                let name = "";
                let mac_address = "";
                let country_id = "";
                let state_id = "";
                let site_id = "";
                let application_id = "";
                let subsystemId="";
                let clientEnergymeterRelationId=""
                let asset_status = 0;
                let connection_status = 0;
                let ofs=''

                generic_asset_id = this.dataEnergymeter[mCount].generic_asset_id;
                if(generic_asset_id !== undefined){
                  this.energyMeterYTDCost(this.clientId,generic_asset_id);
                }
                if(generic_asset_id !== undefined){
                  this.energyMeterYTDCarbonFootprintCost(this.clientId,generic_asset_id);
                }

                if(generic_asset_id !== undefined){
                  this.energyMeterPFCost(this.clientId,generic_asset_id);
                }

                user_id = this.userID;
                name = this.dataEnergymeter[mCount].name;
                mac_address = this.dataEnergymeter[mCount].Gateway_address;
                country_id = this.dataEnergymeter[mCount].country_fk;
                state_id = this.dataEnergymeter[mCount].state_fk;
                site_id = this.dataEnergymeter[mCount].site_id;
                application_id = this.dataEnergymeter[mCount].application_id;
                subsystemId = this.dataEnergymeter[mCount].subsystem_id;
                this.subsystemID = this.dataEnergymeter[mCount].subsystem_id;
                clientEnergymeterRelationId = this.dataEnergymeter[mCount].cemrid;
                asset_status = this.dataEnergymeter[mCount].Current > 0 ? 1 : 0;
                connection_status = this.dataEnergymeter[mCount].network_connection
                ofs=this.dataEnergymeter[mCount]?.out_for_service;

                const energymeterListingsData = {
                  generic_asset_id: generic_asset_id,
                  UserID:  user_id,
                  name:  name,
                  mac_address:  mac_address,
                  country_id:  country_id,
                  state_id:  state_id,
                  site_id: site_id,
                  application_id: application_id,
                  subsystemId,
                  clientEnergymeterRelationId,
                  asset_status,
                  connection_status,
                  ofs,
                  currency:this.dataEnergymeter[mCount]?.currency
                };

                this.energymeterListings.push(energymeterListingsData);

              }
              this.loadingService=false;
              this.EnergymeterAllDeviceSecondArray =this.energymeterListings;
              this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
              this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
              this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
                console.log('eneeneneeencvo',this.EnergymeterAllDeviceSecondArray)

              if(this.loadMainScreen==true){
                this.onRangeChange(this.EnergymeterAllDeviceSecondArray);
              }
              this.loadMainScreen==false;
            }else{
              this.loadingService=false;
            }

          }else{
            this.loadingService=false;
          }

        }else{
          this.loadingService=false;
        }

      }else{
        this.loadingService=false;
      }

    });

    this.service.getDataWithQuery(this.EnergymeterBaseUrl+"/energymeter-all-application-addresses/"+userId+"/"+siteid+"/"+applicationid).then((sRes) =>{

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body[0];
        this.energymeterListings =[];
        this.allAddresses = [];

        if (response.all_applications != undefined){

          if(response.all_applications.length != 0){

            if (response.all_applications.length !== 0) {
              for (let mCount = 0; mCount < response.all_applications.length; mCount++) {

                let id="";
                let site_id=""
                let application_id=""
                let company_name = "";
                let address_1 = "";
                let address_2 = "";
                let latitude = "";
                let longitude = "";

                id = response.all_applications[mCount].id;
                site_id = response.all_applications[mCount].site_id;
                application_id = response.all_applications[mCount].application_id;
                company_name = response.all_applications[mCount].company_name;
                address_1 = response.all_applications[mCount].address_1;
                address_2 = response.all_applications[mCount].address_2;
                latitude = response.all_applications[mCount].latitude;
                longitude = response.all_applications[mCount].longitude;

                const energymeterAddressData = {
                  id: id,
                  site_id: site_id,
                  application_id:application_id,
                  company_name:  company_name,
                  address_1:  address_1,
                  address_2:  address_2,
                  latitude:  latitude,
                  longitude:  longitude
                };

                this.allAddresses.push(energymeterAddressData);

              }
                //provide map address for ballon functionality.
                if(this.allPointerFilterData.length===0){
                  this.allPointerFilterData = this.allAddresses;
                }

            }

          }

        }

      }

    });

  }

  energyMeterDashboard(generic_asset_id,country_id,state_id,index,ofs,sid){


    let device_status = this.dataEnergymeter[index].Current > 0 ? 1 : 0;
    let connection_status = this.dataEnergymeter[index].network_connection

    if(generic_asset_id!= undefined && generic_asset_id != ""){
      localStorage.setItem('generic_asset_id', generic_asset_id);
    }else{
      localStorage.setItem('generic_asset_id', '');
    }

    if(country_id!= undefined && country_id != ""){
      localStorage.setItem('country_id', country_id);
    }else{
      localStorage.setItem('generic_asset_id', '');
    }

    if(state_id!= undefined && state_id != ""){
      localStorage.setItem('state_id', state_id);
    }else{
      localStorage.setItem('state_id', '');
    }
    if(sid!= undefined && sid != ""){
      localStorage.setItem('subsystem_id', sid);
    }else{
      localStorage.setItem('subsystem_id', '');
    }


    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        connection_status:connection_status,
        device_status:device_status,
        energyMeterId:generic_asset_id,
        subsystem_id:sid,
        ofs,
        tab1:this.tabID_1,
        tab2:this.tabID_2,
        tab4:this.tabID_4,
      }
    }
    this.router.navigate(['energy-meter-monitoring'], navigationExtras);
  }

  getEnergymeterAllSites(id){

    this.service.getData(this.EnergymeterBaseUrl+'/clientsites/'+id).then((res) => {

      if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        this.energymeterSitesList = JSON.parse(JSON.stringify(res)).data.body.result2;
        if (this.energymeterSitesList.length !== 0) {

          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        //this.service.showError("Something went wrong...1");
      }
    });

  }

  getEnergymeterAllSitesByID(id){
    this.siteid = id;
    this.applicationid=0;
    this.emSerialNumber=0;
    this.energymeterApplicationList=[];
    this.onEnergymeterSiteSelected(id);
  }

  getEnergymeterAllApplicationsByID(id){
    if(id==='0'){
      this.applicationid = 0;
      this.emSerialNumber=0;
      this.energymeterApplicationList=[];
    }else{
      this.applicationid = id;
      this.emSerialNumber=0;
    }
    this.onEnergymeterApplicationSelected(this.applicationid);

    this.service.getData(this.EnergymeterBaseUrl+"/clientapplications/"+this.clientId+"/"+id).then((res) => {

      if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        this.energymeterApplicationList = JSON.parse(JSON.stringify(res)).data.body;
        if (this.energymeterApplicationList.length !== 0) {

          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError("Something went wrong.");
      }
    });

  }

  getSpecificEnergymeterByID(id){

    this.generic_asset_id = id;

    //this.energyMeterListing(this.clientId,this.siteid,this.applicationid,this.emSerialNumber);
    this.onEnergymeterSingleSelected(this.generic_asset_id);

  }

  //Energymeter Edit Functionality.
  editEnergymeterGroup(generic_asset_id,site_id, application_id, serial_number, user_id, gateway_address){
    const configratorObj = {generic_asset_id:generic_asset_id,site_id:site_id,application_id:application_id,serial_number:serial_number,user_id:user_id,gateway_address:gateway_address,pageType: "edit-configrator"};
    this.router.navigate(['/energy-meter-configuration'], { state: { configratorObj } });
  }

//Energymeter Delete Functionality.
  showEnergymeterDeleteDialog(generic_asset_id,site_id, application_id, serial_number, user_id,subsystem_id,clientEnergymeterRelationId){

    var result = confirm("Are you sure you want to delete this energymeter?");
    if (result) {
      this.service.getData( this.EnergymeterBaseUrl +  "/get-subsystem-name/" + site_id + "/" + application_id+ "/" + this.userID).then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {

          let getSubsystemNameRes = JSON.parse(JSON.stringify(res)).data.body;
          if(getSubsystemNameRes.length > 0){

            this.subsystemID = subsystem_id;
            this.clientEmRelationID = clientEnergymeterRelationId;

            if(getSubsystemNameRes[0].subsystem_id > 0){
              this.service.deleteInfo( this.EnergymeterBaseUrl +  "/emeter-delete/" +generic_asset_id +"/" + this.subsystemID + "/" + this.userID).then((res) => {

                if (JSON.parse(JSON.stringify(res)).data.status === "success") {

                    this.service.showSuccess('Energymeter has been deleted successfully');
                    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                      this.router.navigate(['/device-reports']);
                    });

                }


              });


            }
          }

        }

      });
    }

  }

  //Radio Button Functionality Start From Here.
  private currentCallId = 0;

  onRangeChange(EmArray): void {
    this.meterViewloader=true
    // Increment the call ID to represent the new API call
    const callId = ++this.currentCallId;

    // Initialize the state correctly
    this.mainScreenYTDCost = { YTDCost: 0, YTDUnit: 0, YTDCurrency: '' };
    this.mainScreenYTDCarbonFootprintCost = { YTDCarbonFootprintCost: 0, YTDCarbonFootprintUnit: 0, YTDCarbonFootprintCurrency: '' };
    this.mainScreenPFCost = { PFCost: 0, PFCount: 0 };
    this.mainScreenPDCost = { peak_demand: 0, PDCount: 0 };


    const promises = [];
    this.loading = true;
    this.loadingService=true

    this.EnergymeterAllDeviceSecondArray.forEach(em => {
        const userID = em.UserID;
        const countryID = em.country_id;
        const stateID = em.state_id;
        const generic_asset_id = em.generic_asset_id;
        const selectedRange = this.selectedRange;
        promises.push(
            this.service.getDataWithQuery(`${this.EnergymeterBaseUrl}/energymeter-ytd-cost-by-datefilter/${userID}/${generic_asset_id}/${selectedRange}`).then((sRes) => {
                if (callId === this.currentCallId) { // Check if this is still the latest call
                    let mainScreenYTDResponseArray = JSON.parse(JSON.stringify(sRes)).data;
                    if (mainScreenYTDResponseArray.body && Object.keys(mainScreenYTDResponseArray.body).length !== 0) {
                        let response = mainScreenYTDResponseArray.body;
                        this.mainScreenYTDCost.YTDCost += parseFloat(response[0].YTD_Cost);
                        this.mainScreenYTDCost.YTDUnit += parseFloat(response[0].YTD_Unit);
                        this.mainScreenYTDCost.YTDCurrency = response[0].currency; // Assuming currency will be the same for all
                        em.cost = response[0].YTD_Cost;
                        em.costUnit = response[0].YTD_Unit;
                        // em.currency= response[0].currency;
                    }
                }
            })
        );

        promises.push(
            this.service.getDataWithQuery(`${this.EnergymeterBaseUrl}/energymeter-carbon-footprint-cost-by-datefilter/${userID}/${generic_asset_id}/${selectedRange}`).then((sRes) => {
                if (callId === this.currentCallId) { // Check if this is still the latest call
                    let YTDCarbonFootprintResponseArray = JSON.parse(JSON.stringify(sRes)).data;
                    if (YTDCarbonFootprintResponseArray.body && Object.keys(YTDCarbonFootprintResponseArray.body).length !== 0) {
                        let response = YTDCarbonFootprintResponseArray.body;
                        this.mainScreenYTDCarbonFootprintCost.YTDCarbonFootprintCost += parseFloat(response[0].YTD_Carbon_Footprint_Cost);
                        this.mainScreenYTDCarbonFootprintCost.YTDCarbonFootprintUnit += parseFloat(response[0].YTD_Carbon_Footprint_Unit);
                        this.mainScreenYTDCarbonFootprintCost.YTDCarbonFootprintCurrency = response[0].currency; // Assuming currency will be the same for all
                        em.co2cost = response[0].YTD_Carbon_Footprint_Cost;
                        em.co2unit= response[0].YTD_Carbon_Footprint_Unit;
                        em.co2currency= response[0].currency;
                    }
                }
            })
        );

        promises.push(
            this.service.getDataWithQuery(`${this.EnergymeterBaseUrl}/energymeter-pf-cost-by-datefilter/${userID}/${generic_asset_id}/${selectedRange}`).then((sRes) => {
                if (callId === this.currentCallId) { // Check if this is still the latest call
                    let PFResponseArray = JSON.parse(JSON.stringify(sRes)).data;
                    if (PFResponseArray.body && Object.keys(PFResponseArray.body).length !== 0) {
                        let response = PFResponseArray.body;
                        this.mainScreenPFCost.PFCost += parseFloat(response[0].PowerFactor_Cost);
                        if(parseFloat(response[0].PowerFactor_Cost)>0){
                          this.mainScreenPFCost.PFCount += 1;
                        }
                        em.pfcost = response[0].PowerFactor_Cost;
                    }
                }
            })
        );

        promises.push(
          this.service.getDataWithQueryV2(`${this.EnergymeterBaseUrl}/energymeter-peak-demand-by-datefilter/${userID}/${generic_asset_id}/${selectedRange}`).then((sRes) => {
          // this.service.getDataWithQuery(`http://localhost:3105/emeter/energymeter-peak-demand-by-datefilter/${userID}/${generic_asset_id}/${selectedRange}`).then((sRes) => {
              if (callId === this.currentCallId) { // Check if this is still the latest call
                  let PFResponseArray = JSON.parse(JSON.stringify(sRes)).data;
                  if (PFResponseArray.body && Object.keys(PFResponseArray.body).length !== 0) {
                      let response = PFResponseArray.body;
                      this.mainScreenPDCost.peak_demand += parseFloat(response[0].peak_demand);
                      if(parseFloat(response[0].peak_demand)>0){
                        this.mainScreenPDCost.PDCount += 1;
                      }
                    em.pd = response[0].peak_demand;
                  }
              }
          })
      );

    });

    Promise.all(promises).then(() => {
        if (callId === this.currentCallId) { // Check if this is still the latest call
          this.meterViewloader=false
            this.loading = false;
            this.loadingService=false
        }
    }).catch(error => {
        this.loading = false;
        this.loadingService=false
        this.meterViewloader=false
        console.error('Error in processing promises:', error);
    });
  }

  // Radio Button Functionality End From Here.


  //Energymeter tab-3 code End.

  getallSitesAndGroupsInfo(id) {

    this.service.getData(this.allSitesUrl + "/" + Math.floor(Math.random() * 90 + 10) + id + Math.floor(Math.random() * 9000 + 1000)).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.sitesList = JSON.parse(JSON.stringify(res)).data.body;
        if (this.sitesList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }

  gridLayout() {
    clearTimeout(this._timeOut);
    this.gridLayoutOn = false;
    this.listLayoutOn = true;
  }

  listLayout() {
    this.loadAllDevices();
    this.gridLayoutOn = true;
    this.listLayoutOn = false;
  }

  async getGroupsBySiteId(siteId: any) {
    this.service.getData(this.getApplicationsUrl + "/" + localStorage.getItem('admin_client_id') + "/" + siteId).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.groupList = JSON.parse(JSON.stringify(res)).data.body;
        if (this.groupList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    });
  }

  async getallDevices(clientId, type, limit) {
    limit=this.limit
    let self = this;
    let body;
    if (this.userRoll === 'USER') {
      body = {
        client_id: localStorage.getItem('client_id'),
        user_id: localStorage.getItem('user_id')
      };
    }
    else {
      body = {
        client_id: localStorage.getItem('user_id')
      };
    }
    if (type !== 'interval') {
      this.changeService.loader(true);
    }
    let userID = localStorage.getItem('admin_client_id') === 'null' ? localStorage.getItem('user_id') : localStorage.getItem('admin_client_id');
    if (this.userRoll === 'USER') {
      const site_id = localStorage.getItem('_siteId');
      const id = localStorage.getItem('_groupId');
      const baseUrl= this.assetsListUrl + "/end/" + userID + "?userid=" + this.userID + "&assetFilter=" + this.assetsFilter+"&limit=" + limit +"&offset=" +this.offset

      let url = this.buildUrl(baseUrl,site_id,id)

      this.service.getDataWithQuery(url).then(async (res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
            this.showEmptyError = '';
            this.allDevices = JSON.parse(JSON.stringify(res)).data.body;
            this.changeService.loader(false);

            this.allDevices.forEach((e) => {
              e.noOfSensors = e.connected_sensors.length;
              let isSecondryON = false;

              let colorchangetowhite = false;
              let colorchangetored = false;
              let colorchangetoyellow = false;
              let colorchangetogreen = false;

              e.connected_sensors.forEach((s, i) => {
                let sensors = s.template_id.split("_");
                // if(s.bearing_issue==true) e.bearing_issue = true;
                if (sensors !== undefined && sensors.length > 2) {
                  //s.sno = i + 1;

                  if (s.id === e.id) {
                    s.master = 1;
                  } else {
                    s.master = 0;
                  }
                 //  s.lbl = sensors[0];
                  s.sno=sensors[0];
                  s.sensor = sensors[1];
                  s.parent = sensors[2];
                  e.parentS = sensors[2] === "secondry" ? true : false;

                  if (!isSecondryON) {
                    e.parentS = sensors[2] === "secondry" ? true : false;
                    if (e.parentS) {
                      isSecondryON = true;
                    }
                  }

                  e.new = true;
                  if (e.parentS) {
                    e.imgP = "./assets/motor_n.png";
                    e.asset_type_s = s.asset_type;
                  }


                  switch (s.asset_type) {
                    case "MOTOR":
                      if (e.parentS) {
                        e.imgS = "./assets/motor_n.png";
                      } else {
                        e.imgP = "./assets/motor_n.png";
                      }
                      break;
                    case "GEAR":
                      if (e.parentS) {
                        e.imgS = "./assets/gearbox.png";
                      } else {
                        e.imgP = "./assets/gearbox.png";
                      }
                      break;
                    case "PUMP":
                      if (e.parentS) {
                        e.imgS = "./assets/pump.png";
                      }
                      else {
                        e.imgP = "./assets/pump.png";
                      }
                      break;
                    case "FAN_BLOWER":
                      if (e.parentS) {
                        e.imgS = "./assets/fan.png";
                      } else {
                        e.imgP = "./assets/fan.png";
                      }

                      break;
                    case "JOURNAL_BEARING":
                      if (e.parentS) {
                        e.imgS = "./assets/bearing2.png";
                      } else {
                        e.imgP = "./assets/bearing2.png";
                      }

                      break;
                    case "COMPRESSOR":
                      if (e.parentS) {
                        e.imgS = "./assets/compressor.png";
                      } else {
                        e.imgP = "./assets/compressor.png";
                      }
                      break;
                  }
                }
              });

              e.connected_sensors.sort((a, b) =>
                a.parent > b.parent ? 1 : -1
              );
              e.connected_sensors.sort((a, b) => b.master - a.master);

              e.connected_sensors.forEach((sensorVal, i) => {
                sensorVal.sno = i + 1;
              });
            });

            this.allDeviceSecondArray = this.allDevices;
            let _sId = localStorage.getItem('_siteId');
            let _grpId = localStorage.getItem('_groupId');
            let filter = localStorage.getItem('_filterVal');
            let search = localStorage.getItem('_searchVal');
            if (search !== 'null') {
              this.allDeviceSecondArray = this.allDeviceSecondArray.filter(tag => tag.name.toLowerCase().indexOf(search) >= 0);
            }
            else if (filter !== 'null') {
              this.allDeviceSecondArray = this.allDeviceSecondArray.filter(result => result.status === filter);
            }
            else if (parseInt(_sId) > 0 && parseInt(_sId) !== null) {
              this.allDeviceSecondArray = this.allDeviceSecondArray.filter(result => result.client_site_id === parseInt(_sId));
            }
            else if (parseInt(_grpId) != null && parseInt(_grpId) > 0) {
              this.allDeviceSecondArray = this.allDeviceSecondArray.filter(result => result.client_application_id === parseInt(_grpId));
            }
            else {
              this.allDeviceSecondArray = this.allDevices;
            }
            this.checkIfPowertrainAssetsExists();
          } else {
            this.changeService.loader(false);
            this.showEmptyError = 'No Assets Available!';
          }
        } else {
          this.changeService.loader(false);
          this.service.showError('Something went wrong.');
        }
      });
    } else
    {
      //this is for client admin( for ex:-Bobby Sagoo)
      this.rotatingAssetLoader = true;
      if(limit !=undefined && this.offset != undefined){
        const site_id = localStorage.getItem('_siteId');
        const id = localStorage.getItem('_groupId');
        let baseUrl= `${this.getRotatingAssets}getRotatingAssets/${this.userID}`
        + "?assetFilter="
        + this.assetsFilter
        + "&limit=" +
        limit +
        "&offset=" +
        this.offset

        let url = this.buildUrl(baseUrl,site_id,id)
        this.service.getDataWithQuery(url).then((res) => {
          this.rotatingAssetLoader = false;
          if (JSON.parse(JSON.stringify(res)).data.status === "success") {
            if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
              this.allDevices = JSON.parse(JSON.stringify(res)).data.body;
              this.allDevicesFilter = JSON.parse(JSON.stringify(res)).data.body;
              this.changeService.loader(false);
              this.showEmptyError = "";
              this.rotatingAssetExists = true;
              //Device print
             this.totalSize=JSON.parse(JSON.stringify(res)).data.totalNumberOfGroups;
              this.allDevices.forEach((e) => {
                e.connected_sensors.sort((a, b) => b.lbl - a.lbl);
                e.noOfSensors = e.connected_sensors.length;
                e.connected_sensors.forEach((s, i) => {
                  // s.bearing_issue==true ?e.bearing_issue = true:e.bearing_issue = false;
                  // s.bearing_issue==true ?e.bearing_issue_color = e.color:e.bearing_issue_color = 'white';
                  let sensors = s.template_id.split("_");
                  if (sensors !== undefined && sensors.length > 2) {
                    //s.sno = i + 1;
                    if(s.device_sno === 1) {
                      e.orientation = s.orientation;
                    }
                    if (s.id === e.id) {
                      s.master = 1;
                    } else {
                      s.master = 0;
                    }
                    s.lbl = sensors[0];
                    s.sno = sensors[0];

                    s.sensor = sensors[1];
                    s.parent = sensors[2];
                    if (sensors[2] == "secondry" || sensors[1] == "couple") {
                      e.parentS = true;
                    } else {
                      e.parentS = false;
                    }
                    e.new = true;
                    if (e.parentS) {
                      e.imgP = "./assets/motor_n.png";
                      e.asset_type_s = s.asset_type;
                    }

                    switch (s.asset_type) {
                      case "MOTOR":
                        if (e.parentS) {
                          e.imgS = "./assets/motor_n.png";
                        } else {
                          e.imgP = "./assets/motor_n.png";
                        }
                        break;
                      case "GEAR":
                        if (e.parentS) {
                          e.imgS = "./assets/gearbox.png";
                        } else {
                          e.imgP = "./assets/gearbox.png";
                        }
                        break;
                      case "PUMP":
                        if (e.parentS) {
                          e.imgS = "./assets/pump.png";
                        } else {
                          e.imgP = "./assets/pump.png";
                        }
                        break;
                      case "FAN_BLOWER":
                        if (e.parentS) {
                          e.imgS = "./assets/fan.png";
                        } else {
                          e.imgP = "./assets/fan.png";
                        }
                        break;
                      case "JOURNAL_BEARING":
                        if (e.parentS) {
                          e.imgS = "./assets/bearing2.png";
                        } else {
                          e.imgP = "./assets/bearing2.png";
                        }
                        break;
                      case "COMPRESSOR":
                        if (e.parentS) {
                          e.imgS = "./assets/compressor.png";
                        } else {
                          e.imgP = "./assets/compressor.png";
                        }
                        break;
                    }
                  }
                });

                // e.connected_sensors.sort((a, b) =>
                //   a.parent > b.parent ? 1 : -1
                // );
                // e.connected_sensors.sort((a, b) => b.master - a.master);
                // e.connected_sensors.sort((a, b) => b.device_sno - a.device_sno);
              });
              this.filterCall ? "" : this.allDeviceSecondArray = this.allDevices;
              this.assetsFilter === "ALL" ? this.assetFilterArray = this. allDevices:""
              this.checkIfPowertrainAssetsExists()
            } else {
              this.changeService.loader(false);
              this.allDeviceSecondArray = [];
              this.showEmptyError = "No Assets Available!";
              this.rotatingAssetExists = false;
            }
          } else {
            this.changeService.loader(false);
            this.service.showError("Something went wrong.");
          }
        });

      }
      else{
        const site_id = localStorage.getItem('_siteId');
        const id = localStorage.getItem('_groupId');
        limit=10;
        this.offset=0;
        let baseUrl= `${this.getRotatingAssets}getRotatingAssets/${this.userID}`
        + "?assetFilter="
        + this.assetsFilter
        + "&limit=" +
        limit +
        "&offset=" +
        this.offset

        let url = this.buildUrl(baseUrl,site_id,id)
        this.service.getDataWithQuery(url)
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "success") {
            if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
              this.allDevices = JSON.parse(JSON.stringify(res)).data.body;
              this.changeService.loader(false);
              this.showEmptyError = "";
              this.rotatingAssetLoader = true;
              //Device print
             this.totalSize=JSON.parse(JSON.stringify(res)).data.totalNumberOfGroups;
              this.allDevices.forEach((e) => {
                e.connected_sensors.sort((a, b) => b.lbl - a.lbl);
                e.noOfSensors = e.connected_sensors.length;
                e.connected_sensors.forEach((s, i) => {
                  // s.bearing_issue==true ?e.bearing_issue = true:e.bearing_issue = false;
                  // s.bearing_issue==true ?e.bearing_issue_color = e.color:e.bearing_issue_color = 'white';

                  let sensors = s.template_id.split("_");
                  if (sensors !== undefined && sensors.length > 2) {
                    //s.sno = i + 1;
                     if(s.device_sno === 1) {
                      e.orientation = s.orientation;
                    }
                    if (s.id === e.id) {
                      s.master = 1;
                    } else {
                      s.master = 0;
                    }
                    s.lbl = sensors[0];
                    s.sno = sensors[0];

                    s.sensor = sensors[1];
                    s.parent = sensors[2];
                    if (sensors[2] == "secondry" || sensors[1] == "couple") {
                      e.parentS = true;
                    } else {
                      e.parentS = false;
                    }
                    e.new = true;
                    if (e.parentS) {
                      e.imgP = "./assets/motor_n.png";
                      e.asset_type_s = s.asset_type;
                    }

                    switch (s.asset_type) {
                      case "MOTOR":
                        if (e.parentS) {
                          e.imgS = "./assets/motor_n.png";
                        } else {
                          e.imgP = "./assets/motor_n.png";
                        }
                        break;
                      case "GEAR":
                        if (e.parentS) {
                          e.imgS = "./assets/gearbox.png";
                        } else {
                          e.imgP = "./assets/gearbox.png";
                        }
                        break;
                      case "PUMP":
                        if (e.parentS) {
                          e.imgS = "./assets/pump.png";
                        } else {
                          e.imgP = "./assets/pump.png";
                        }
                        break;
                      case "FAN_BLOWER":
                        if (e.parentS) {
                          e.imgS = "./assets/fan.png";
                        } else {
                          e.imgP = "./assets/fan.png";
                        }
                        break;
                      case "JOURNAL_BEARING":
                        if (e.parentS) {
                          e.imgS = "./assets/bearing2.png";
                        } else {
                          e.imgP = "./assets/bearing2.png";
                        }
                        break;
                      case "COMPRESSOR":
                        if (e.parentS) {
                          e.imgS = "./assets/compressor.png";
                        } else {
                          e.imgP = "./assets/compressor.png";
                        }
                        break;
                    }
                  }
                });

                e.connected_sensors.sort((a, b) =>
                  a.parent > b.parent ? 1 : -1
                );
                e.connected_sensors.sort((a, b) => b.master - a.master);
                e.connected_sensors.sort((a, b) => b.device_sno - a.device_sno);
              });
              this.filterCall ? "" : this.allDeviceSecondArray = this.allDevices;
              this.assetsFilter === "ALL" ? this.assetFilterArray = this. allDevices:""
            }
            else {
              this.changeService.loader(false);
              this.allDeviceSecondArray = [];
              this.showEmptyError = "No Assets Available!";
              this.rotatingAssetExists = false;
            }
          } else {
            this.changeService.loader(false);
            this.service.showError("Something went wrong.");
          }
        });

      }

    }
  }

  public handlePage(e: any) {
   this.currentPage = e.pageIndex+1;

   //limit
   this.limit =  e.pageSize;

   //offset
   this.offset = e.pageSize*(this.currentPage-1);
   this.getallDevices(this.clientId, "interval", this.limit);
   }
   filterMethod(event) {
    localStorage.setItem('_groupId', null);
    localStorage.setItem('_siteId', null);
    localStorage.setItem('_filterVal', event);
    localStorage.setItem('_searchVal', null);
    let filterValue;
    if (event === 'All Assets') {
      this.allDeviceSecondArray = this.allDevices;
    } else {
      filterValue = this.allDevices.filter(item => item.status === event);
      this.allDeviceSecondArray = filterValue;
    }
   }

   searchData(ev) {
    if(ev !=""){
      clearTimeout(this._timeOut);
    }
    else{
      this.loadAllDevices();
    }
    localStorage.setItem('_groupId', null);
    localStorage.setItem('_siteId', null);
    localStorage.setItem('_filterVal', null);
    const term = ev.toLowerCase();
    localStorage.setItem('_searchVal', term);
    this.allDeviceSecondArray = this.allDevices.filter(tag => tag.name.toLowerCase().indexOf(term) >= 0 || tag.motor_serial_no.toLowerCase().indexOf(term) >= 0);
    if (this.allDeviceSecondArray.length === 0) {
      this.showEmptyError = 'No Results';
    } else {
      this.showEmptyError = '';
    }
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  async getEnergymerterGroupsBySiteId(siteId: any) {

    this.EnergymetergroupList =[];
    let body;
    if (this.userRoll === "USER") {
      body = {
        client_id: localStorage.getItem("client_id"),
        user_id: localStorage.getItem("user_id"),
        site_id: siteId,
      };
    } else {
      body = {
        client_id: localStorage.getItem("user_id"),
        site_id: siteId,
      };
    }
    this.service
      .getData( this.EnergymeterBaseUrl +  "/client-all-sites/" +  this.clientId +   "/" +   siteId ).then((res) => {

        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          this.EnergymetergroupList = JSON.parse(JSON.stringify(res)).data.body;
          if (this.EnergymetergroupList.length !== 0) {
            this.showList = true;
            this.emptyMsg = false;
          } else {
            this.showList = false;
            this.emptyMsg = true;
          }
        } else {
          this.showList = false;
          this.emptyMsg = true;
          this.service.showError("Something went wrong.");
        }
      });
  }


  onEnergymeterSiteSelected(id) {

    this.EnergymetersiteFilterValue = [];
    this.EnergymetergroupList = [];
    this.energymeterApplicationList = [];
    this.allPointer = [];
    this.loadingService=true;
    if (this.listLayoutOn) {
      if (parseInt(id) === 0) {
           console.log(this.EnergymeterAllDeviceSecondArray,'EnergymeterAllDeviceSecondArray')
        this.EnergymetersiteFilterValue = this.energymeterListings;
        this.EnergymeterAllDeviceSecondArray = this.EnergymetersiteFilterValue;
        this.allPointer = this.allAddresses;
        this.allPointerFilterData = this.allPointer;

        //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
        this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
        this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

        this.showEmptyError = "";
        this.gridLayoutOn = false;
        this.loadingService=false;
      } else {
        this.EnergymetersiteFilterValue = this.energymeterListings.filter(
          (result) => result.site_id === parseInt(id));
        this.EnergymeterAllDeviceSecondArray = this.EnergymetersiteFilterValue;
        this.allPointer = this.allAddresses.filter((result) => result.site_id === parseInt(id));
        this.allPointerFilterData = this.allPointer;

        //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
        this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
        this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

        this.getEnergymerterGroupsBySiteId(id);
        if (this.EnergymeterAllDeviceSecondArray.length === 0) {
          this.showEmptyError = "No Energymeter associated.";
        } else {
          this.showEmptyError = "";
          this.gridLayoutOn = false;
        }
        this.loadingService=false;
      }
    } else {

      if (parseInt(id) === 0) {
        this.EnergymetersiteFilterValue = this.energymeterListings;
        this.EnergymeterAllDeviceSecondArray = this.EnergymetersiteFilterValue;
        this.allPointer = this.allAddresses;
        this.allPointerFilterData = this.allPointer;

        //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
        this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
        this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

        this.showEmptyError = "";
        this.gridLayoutOn = true;
        this.loadingService=false;
      }
      else {

        clearTimeout(this._timeOut);
        this.EnergymetersiteFilterValue = this.energymeterListings.filter(
          (result) => result.site_id === parseInt(id)        );
        this.EnergymeterAllDeviceSecondArray = this.EnergymetersiteFilterValue;

        this.allPointer = this.allAddresses.filter((result) => result.site_id === parseInt(id));
        this.allPointerFilterData = this.allPointer;

        //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
        this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
        this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

        this.getEnergymerterGroupsBySiteId(id);
        if (this.EnergymeterAllDeviceSecondArray.length === 0) {
          this.gridLayoutOn = false;
          this.showEmptyError = "No Energymeter associated.";
        } else {
          this.showEmptyError = "";
          this.gridLayoutOn = true;
        }
        this.loadingService=false;
      }
    }
  }

  onEnergymeterApplicationSelected(id) {
     this.EnergymeterApplicationFilterValue = [];
     this.loadingService=true;
     if (this.listLayoutOn) {

       if(id =='0'){


         this.EnergymeterAllDeviceSecondArray = this.EnergymetersiteFilterValue;
         this.allPointerFilterData = this.allPointer;

         //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
         this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
         this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
         this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
         this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

         this.EnergymetergroupList = [];
         this.showEmptyError = "";
         this.gridLayoutOn = false;
         this.loadingService=false;
       } else {
         this.EnergymeterApplicationFilterValue = this.energymeterListings.filter(
           (result) => result.application_id === parseInt(id));
         this.EnergymeterAllDeviceSecondArray = this.EnergymeterApplicationFilterValue;
         this.allPointerFilterData = this.allAddresses.filter((result) => result.application_id === parseInt(id));

         //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
         this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
         this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
         this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
         this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

         if (this.EnergymeterAllDeviceSecondArray.length === 0) {
           this.showEmptyError = "No Energymeter associated.";
         } else {
           this.showEmptyError = "";
           this.gridLayoutOn = false;
           this.loadingService=false;
         }
       }
     } else {

       if(id =='0'){
         this.EnergymeterAllDeviceSecondArray = this.EnergymetersiteFilterValue;
         this.allPointerFilterData = this.allPointer;

         //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
         this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
         this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
         this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
         this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

         this.showEmptyError = "";
         this.gridLayoutOn = true;
         this.loadingService=false;
       }
       else {
         clearTimeout(this._timeOut);
         this.EnergymeterApplicationFilterValue = this.energymeterListings.filter(
           (result) => result.application_id === parseInt(id)
         );
         this.EnergymeterAllDeviceSecondArray = this.EnergymeterApplicationFilterValue;

         this.allPointerFilterData = this.allAddresses.filter((result) => result.application_id === parseInt(id));

         //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
         this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
         this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
         this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
         this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

         if (this.EnergymeterAllDeviceSecondArray.length === 0) {
           this.gridLayoutOn = false;
           this.showEmptyError = "No Energymeter associated.";
         } else {
           this.showEmptyError = "";
           this.gridLayoutOn = true;
         }
         this.loadingService=false;
       }
     }

   }

  onEnergymeterSingleSelected(generic_asset_id) {
console.log(generic_asset_id,'generic_asset_id')
    this.loadingService=true;

    if (this.listLayoutOn) {

      if(parseInt(generic_asset_id) ===0){

        //this.EnergymeterApplicationFilterValue = [];
        this.EnergymeterAllDeviceSecondArray = this.EnergymeterApplicationFilterValue;
        //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
        this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
        this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

        //this.EnergymetergroupList = [];
        this.showEmptyError = "";
        this.gridLayoutOn = true;
        this.loadingService=false;

      }else{
        this.EnergymeterSingleFilterValue = this.energymeterListings.filter(
          (result) => result.generic_asset_id === parseInt(generic_asset_id)
        );
        this.EnergymeterAllDeviceSecondArray = this.EnergymeterSingleFilterValue;

        //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
        this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
        this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

        if (this.EnergymeterAllDeviceSecondArray.length === 0) {
          this.showEmptyError = "No Energymeter associated.";
        } else {
          this.showEmptyError = "";
          this.gridLayoutOn = false;
        }
        this.loadingService=false;

      }

    } else {

      if(parseInt(generic_asset_id) ===0){

        //this.EnergymeterApplicationFilterValue = [];
        this.EnergymeterAllDeviceSecondArray = this.EnergymeterApplicationFilterValue;

        //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
        this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
        this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

        //this.EnergymetergroupList = [];
        this.showEmptyError = "";
        this.gridLayoutOn = true;
        this.loadingService=false;

      }else{
        clearTimeout(this._timeOut);
        console.log(this.energymeterListings,'this.energymeterListings',generic_asset_id)
        this.EnergymeterSingleFilterValue = this.energymeterListings.filter(
          (result) => result.generic_asset_id === parseInt(generic_asset_id)
        );
        this.EnergymeterAllDeviceSecondArray = this.EnergymeterSingleFilterValue;
        console.log(this.EnergymeterAllDeviceSecondArray,'ndsos')

        //total YTD Cost, Total YTD Carbon Footprint Cost, Total YTD Powerfactor Cost
        this.getTotalYTDCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray);
        this.getTotalPFCost(this.EnergymeterAllDeviceSecondArray);
        this.onRangeChange(this.EnergymeterAllDeviceSecondArray);

        if (this.EnergymeterAllDeviceSecondArray.length === 0) {
          this.gridLayoutOn = false;
          this.showEmptyError = "No Energymeter associated.";
        } else {
          this.showEmptyError = "";
          this.gridLayoutOn = true;
        }
        this.loadingService=false;

      }

    }
  }

  getTotalYTDCost(EMArray): number {
    return EMArray.reduce((total, energymeterData) => {
      return total + (parseFloat(this.YTDCost[energymeterData.serialNumber]?.YTDCost) || 0);
    }, 0);
  }

  getTotalYTDCarbonFootprintCost(EMArray): number {
    return EMArray.reduce((total, energymeterData) => {
      return total + (parseFloat(this.YTDCarbonFootprintCost[energymeterData.serialNumber]?.YTDCarbonFootprintCost) || 0);
    }, 0);
  }

  getTotalPFCost(EMArray): number {
    return EMArray.reduce((total, energymeterData) => {
      return total + (parseFloat(this.PFCost[energymeterData.serialNumber]?.PFCost) || 0);
    }, 0);
  }



  onSiteSelected(id) {
    localStorage.setItem('_filterVal', null);
    localStorage.setItem('_searchVal', null);
    localStorage.setItem('_siteId', id);
    if (this.listLayoutOn) {
      if (parseInt(id) === 0) {
        this.siteFilterValue = [];
        this.groupFilterValue = [];
        localStorage.setItem('_groupId', null);
        this.allDeviceSecondArray = this.allDevices;
        this.groupList = [];
        this.showEmptyError = "";
        this.gridLayoutOn = false;
      } else {
        // this.siteFilterValue = this.allDevices.filter(result => result.site_id === parseInt(id));
        // this.allDeviceSecondArray = this.siteFilterValue;
         this.getallDevices(this.clientId, 'device', this.pageSize)

        this.getGroupsBySiteId(id);
        if (this.allDeviceSecondArray.length === 0) {
          this.showEmptyError = "No assets associated.";
        } else {
          this.showEmptyError = "";
          this.gridLayoutOn = false;
        }
      }
    } else {
      if (parseInt(id) === 0) {
        localStorage.setItem('_siteId', null);
        this.siteFilterValue = [];
        this.groupFilterValue = [];
        localStorage.setItem('_groupId', null);
        this.allDeviceSecondArray = this.allDevices;
        this.groupList = [];
        this.showEmptyError = "";
        this.gridLayoutOn = true;
        this.getallDevices(this.clientId, 'device', this.pageSize)
      } else {
        clearTimeout(this._timeOut);
        // this.siteFilterValue = this.allDevices.filter(result => result.site_id === parseInt(id));
        // this.allDeviceSecondArray = this.siteFilterValue;
        this.getallDevices(this.clientId, 'device', this.pageSize)
        this.getGroupsBySiteId(id);
        if (this.allDeviceSecondArray.length === 0) {
          this.showEmptyError = "No assets associated.";
        } else {
          this.showEmptyError = "";
          this.gridLayoutOn = true;
        }
      }
    }

    if(this.showPowertrain){
        // Update rendering list
       if(id==0){
        this.filtered_piezo_asset_list=this.piezo_asset_list;
        this.powertrainList=this.powertrainInitialList
      }else{
        this.filtered_piezo_asset_list=this.piezo_asset_list.filter(p=>p.site_id == id);;
        this.powertrainList=this.powertrainInitialList.filter(p=>p.site_id == id);
       }
    }
  }

  onGroupSelected(id) {
    localStorage.setItem('_searchVal', null);
    localStorage.setItem('_filterVal', null);
    localStorage.setItem('_groupId', id);
    if (parseInt(id) === 0) {
      localStorage.setItem('_siteId', null);
      this.groupFilterValue = [];
      // if (this.siteFilterValue.length != 0) {
      //   for (let i = 0; i < this.siteFilterValue.length; i++) {
      //     this.siteFilterValue = this.allDevices.filter(result => result.site_id === parseInt(this.siteFilterValue[i].site_id));
      //   }
      //   this.allDeviceSecondArray = this.siteFilterValue;
      // } else {
      //   this.allDeviceSecondArray = this.allDevices;
      //   if (this.allDeviceSecondArray.length === 0) {
      //     this.showEmptyError = "No assets associated.";
      //   } else {
      //     this.showEmptyError = "";
      //     // this.gridLayoutOn = false;
      //   }
      // }
      this.getallDevices(this.clientId, 'device', this.pageSize)
    } else {
      clearTimeout(this._timeOut);
      // this.groupFilterValue = this.allDevices.filter(result => result.application_id === parseInt(id));
      // this.allDeviceSecondArray = this.groupFilterValue;
      this.getallDevices(this.clientId, 'device', this.pageSize)
      if (this.allDeviceSecondArray.length === 0) {
        this.showEmptyError = "No assets associated.";
      } else {
        this.showEmptyError = "";
        // this.gridLayoutOn = false;
      }
    }
    if(this.showPowertrain){
    // Update rendering list
      if(id==0){
         this.filtered_piezo_asset_list=this.piezo_asset_list;
         this.powertrainList=this.powertrainInitialList;
      }else{
        this.powertrainList=this.powertrainInitialList.filter(p=>p.application_id == id);
        this.filtered_piezo_asset_list=this.piezo_asset_list.filter(p=>p.application_id == id);
       }
    }
  }


  getDeviceInfo(id, idx, status, assets_id, view) {
    const _deviceInfo = this.allDevices.filter(d => d.id === assets_id)[0];
    const appNa = _deviceInfo.application === undefined ? 'null' : _deviceInfo.application.name;
    localStorage.setItem('applicationName', appNa);
    const vDataF = _deviceInfo === undefined ? 15 : _deviceInfo.data_frequency;
    localStorage.setItem('dataFrq', vDataF);
    let deviceInfo: any;
    this.service.getData(this.assetsUrlEdit + "/" + assets_id + "/" + this.mac_address).then(result => {
      if (JSON.parse(JSON.stringify(result)).data.status === 'success') {
        deviceInfo = {
          assetsInfo: JSON.parse(JSON.stringify(result)).data.body[0]
        };
        const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
          width: '410px',
          height: 'auto',
          data: {
            type: 'motorPlateDialogBox',
            asset_id: assets_id,
            deviceInfo,
            deviceStatus: result,
            lastUpdate: this._lastUpdate
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result !== undefined) {
            for (let a = 0; a < this.breadcrumbsArray.length; a++) {
              this.objBread = {
                page_ref: this.breadcrumbsArray[a].page_ref,
                page_title: this.breadcrumbsArray[a].page_title
              };
            }
            if (result.type === 'device-reporting') {
              const navigationExtras = {
                skipLocationChange: true,
                queryParams: {
                  pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : '',
                  deviceId: id,
                  assetid: assets_id,
                  deviceStatus: result.deviceInfo.assetsInfo.device.health === 'ERROR' ?
                    'PROBABLE FAULT' + ' ' + '(' + result.deviceInfo.assetsInfo.device.health_detail + ')' :
                    result.deviceInfo.assetsInfo.device.health,
                  errorStatus: result.deviceInfo.assetsInfo.device.health,
                  deviceName: result.deviceStatus.data.body.name,
                }
              };
              this.router.navigate(['user-device-info-new'], navigationExtras);
            }
          }
        });
      } else {
        this.service.showError("Something went wrong.");
      }
    });
  }

  viewAsset(id, idx, obj) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '1100px',
      maxWidth: '85vw',
      data: {
        type: 'sensorNewDialogBox',
        asset_type: obj.asset_type,
        online_status: obj.live_status,
        client_asset_id: id,
        clientId: localStorage.getItem('admin_client_id') === 'null' ? localStorage.getItem('user_id') : localStorage.getItem('admin_client_id'),
        inventory_id: obj.inventory_id,
        asset_obj: obj
      }
    });
  };

  public assetFilterArray = []
  public filterCall = false
  async viewAssetsList(type: any) {
    this.filterCall = false

    this.assetsFilter = type;

    const id = localStorage.getItem('_groupId');
    // console.log(id);

    if (type === 'ALL') {

      this.filterCall = true
      // console.log(this.allDevices)
      await this.getallDevices(this.clientId, 'device', this.pageSize)

      if (id === "0" || id === null || id === "null") {

        const site_id = localStorage.getItem('_siteId');

        if (site_id === "null" || site_id === "0") {

          // this.allDeviceSecondArray = this.allDevices
          // this.getallDevices(this.clientId, 'device', this.pageSize);
          this.allDeviceSecondArray = [...this.assetFilterArray];
          this.showEmptyError=""

        } else {

          this.siteFilterValue = this.assetFilterArray.filter(result => result.site_id === parseInt(site_id));

          // this.allDeviceSecondArray = this.siteFilterValue;
          this.allDeviceSecondArray = [...this.siteFilterValue];
          // console.log(this.siteFilterValue)
          this.showEmptyError=""

        }

      } else {
        // Apply application_id filter
        this.groupFilterValue = this.assetFilterArray.filter(result => result.application_id === parseInt(id))
        // this.allDeviceSecondArray = this.groupFilterValue;
        this.allDeviceSecondArray = [...this.groupFilterValue];
        // console.log(this.groupFilterValue)
        this.showEmptyError=""
      }


    }
    // else if(type === "HEALTHY"){
    //   this.filterCall = true
    //   // console.log(this.allDevices)
    //   await this.getallDevices(this.clientId, 'device', this.pageSize);

    //   if (id === "0" || id === null || id === "null") {

    //     // console.log(this.assetFilterArray)
    //     const site_id = localStorage.getItem('_siteId');

    //     if (site_id === "null" || site_id === "0") {

    //       this.allDeviceSecondArray = this.allDevices
    //       this.showEmptyError=""

    //     } else {

    //       this.siteFilterValue = this.assetFilterArray.filter(result => result.site_id === parseInt(site_id));
    //       this.allDeviceSecondArray = this.siteFilterValue.filter(result => result.status === "HEALTHY");

    //       // console.log(this.siteFilterValue)
    //       this.showEmptyError=""

    //     }

    //   } else {
    //     // Apply application_id filter
    //     this.groupFilterValue = this.assetFilterArray.filter(result => result.application_id === parseInt(id))
    //     this.allDeviceSecondArray = this.groupFilterValue.filter(result => result.status === "HEALTHY");
    //     // console.log(this.groupFilterValue)
    //     this.showEmptyError=""
    //   }

    // }
     else {
      await this.getallDevices(this.clientId, 'device', this.pageSize);
  }
   }





  async addAssets() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: this.pageName
      }
    };
    this.router.navigate(['/clients-add-assets'], navigationExtras);
  }

  async editAssets(assetsID, obj) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        online_status: obj.live_status,
        assets_id: assetsID,
        pageRef: 'client-assets',
        state: "FROM_LIST"
      }
    };
    this.router.navigate(['/clients-add-assets'], navigationExtras);
  }


  async serviceBookOpen(id, idx) {
    this.service.getData(this.assetServiceUrl + '/' + id).then(res => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        if (JSON.parse(JSON.stringify(res)).data.body.last_service_date === undefined) {
          this.fromDate = this.calendar.getToday();
        } else {
          var datelastSerobj = new Date(JSON.parse(JSON.stringify(res)).data.body.last_service_date);
          var last_month = datelastSerobj.getMonth() + 1;
          var last_day = datelastSerobj.getDate();
          var last_year = datelastSerobj.getFullYear();
          this.fromDate = new NgbDate(last_year, last_month, last_day)
        }
        if (JSON.parse(JSON.stringify(res)).data.body.next_service_date === undefined) {
          this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 360);
        } else {
          var dateNextSerobj = new Date(JSON.parse(JSON.stringify(res)).data.body.next_service_date);
          var next_month = dateNextSerobj.getMonth() + 1;
          var next_day = dateNextSerobj.getDate();
          var next_year = dateNextSerobj.getFullYear();
          this.toDate = new NgbDate(next_year, next_month, next_day);
        }
        const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
          width: '400px',
          maxWidth: '85vw',
          data: {
            type: 'ServiceBookOpen',
            data: { "service_category": JSON.parse(JSON.stringify(res)).data.body.service_category === null ? "Planned Repair/Service" : JSON.parse(JSON.stringify(res)).data.body.service_category, id: JSON.parse(JSON.stringify(res)).data.body.id, "service_detail": JSON.parse(JSON.stringify(res)).data.body.service_detail, asset_id: JSON.parse(JSON.stringify(res)).data.body.asset_id, last_service_date: this.fromDate, last_service_performed: JSON.parse(JSON.stringify(res)).data.body.last_service_performed, service_details: "", service_performed_by: JSON.parse(JSON.stringify(res)).data.body.service_performed_by, next_service_date: this.toDate },
            client_asset_id: id,
            clientId: this.userID
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result !== undefined) {
            if (result.type === "ServiceBookOpen") {

              if (result.data.last_service_date === undefined) {
                this.service.showError("Last service date can't be empty!");
              } else if (result.data.last_service_performed === undefined) {
                this.service.showError("Last service performed date can't be empty!");
              } else if (result.data.service_performed_by === undefined) {
                this.service.showError("service performed by date can't be empty!");
              } else {
                const monthNames = [
                  'January', 'February', 'March', 'April', 'May', 'June', 'July',
                  'August', 'September', 'October', 'November', 'December'
                ];
                let last_service_date = result.data.last_service_date.day + ' ' + monthNames[result.data.last_service_date.month - 1] + ' ' + result.data.last_service_date.year;
                let next_service_date = result.data.next_service_date.day + ' ' + monthNames[result.data.next_service_date.month - 1] + ' ' + result.data.next_service_date.year;

                if (result.data.id === undefined) {
                  let resultObj = {
                    "asset_id": result.client_asset_id,
                    "last_service_date": moment(last_service_date).format('YYYY-MM-DD'),
                    "next_service_date": moment(next_service_date).format('YYYY-MM-DD'),
                    "service_detail": result.data.service_detail,
                    "last_service_performed": result.data.last_service_performed,
                    "service_performed_by": result.data.service_performed_by,
                    "user_id": localStorage.getItem('user_id'),
                    "service_category": result.data.service_category
                  }
                  this.service.postData(this.assetServiceUrl, resultObj).then(res => {
                    if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
                      this.service.showSuccess(JSON.parse(JSON.stringify(res)).data.message);
                    } else {
                      this.service.showError("Something went wrong");
                    }
                  });
                } else {
                  let body = {
                    "asset_id": result.client_asset_id,
                    "last_service_date": moment(last_service_date).format('YYYY-MM-DD'),
                    "next_service_date": moment(next_service_date).format('YYYY-MM-DD'),
                    "service_detail": result.data.service_detail,
                    "last_service_performed": result.data.last_service_performed,
                    "service_performed_by": result.data.service_performed_by,
                    "user_id": localStorage.getItem('user_id'),
                    "service_category": result.data.service_category
                  };
                  this.service.putData(this.assetServiceUrl + '/' + result.data.id, body).then(res => {
                    this.changeService.loader(false);
                    if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
                      this.service.showSuccess(JSON.parse(JSON.stringify(res)).data.message);
                    } else {
                      this.service.showError("Something went wrong");
                    }
                  });
                }
              }
            }
          }
        });
      }
    });
  }



  checkPlantDashboard() {
    // this.router.navigate(['/plant-dashboard']);
    this.viewPlantDialogBox();
  }


  public alertSettings(assetId: Number, deviceId: Number, asset_obj: any): void {
    const alertDialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '1220px',
      maxWidth: '100%',
      disableClose: false,
      data: {
        type: 'NotifyAlertStstem',
        assetId: assetId,
        clientId: this.clientId,
        deviceId: deviceId,
        asset_obj: asset_obj
      }
    });
  };



  viewPlantDialogBox() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '1240px',
      maxWidth: '100%',
      data: {
        type: 'plantDailogBox'
      }
    });
  };

  async rebootDevice(assetId, i) {
    let bodyInfo = {
      "reboot_status": "1"
    }
    this.service.putData(this.updateRebootStatus + `/reboot/${assetId}`, bodyInfo).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.service.showSuccess("Device reboot initiated");
      } else {
        this.service.showError("Something went wrong");
      }
    });
  }

  isExpanded: boolean;
  isDataList: boolean = false;
  tempObj: any = {};
  openExtededBox(assetInfo) {
    this.extendedChildList = [];
    if (assetInfo != null) {
      if (assetInfo.group_id === null) {
        this.tempObj = assetInfo;
        this.extendedChildList.push(assetInfo);
      } else {
        this.service.getData(`${this.assetsListUrl}/v2/list/view/${assetInfo.group_id}/${this.userID}`).then(res => {

          this.extendedChildList = JSON.parse(JSON.stringify(res)).data.body;
        }).catch((error) => {
        });
      }
    } else {
      this.extendedChildList.push(this.tempObj);
    }
  }

  showDeleteAlert() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: 'auto',
      data: {
        type: 'delete-dialog-open-with-childs',
        typeOf: 'asset'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) { }
    });
  }
  getEboilerList(){
    this.router.navigate(['eBoiler-room'])
  }
  generateRandomWidths(lenVar: number) {
    const length = Math.min(lenVar, 25);
    this.randomWidths = Array.from({ length }, () => Math.random() < 0.5 ? 194.29 : 323);
  }


  //------------------------------------------- POWERRTRAIN STARTS------------------------------------
  public powertrainGetUrl = BaseUrlConstantsService.POWERTRAINS_GET_API
  public BHEL_ON_PREM: boolean = BaseUrlConstantsService.BHEL_ON_PREM;

    private showPowertrain:boolean = false;
    private isPowertrainEnabled:boolean = false;
    private powertrainList:powerTrain[]=[];
    private powertrainInitialList:powerTrain[]=[];
    private powertrainAssetList=[];
    private powertrainAsset=0;
    private nonPowertrainAsset=0;
    powertrainLoader=false;

    onPowertrainToggleChange(event){
      const {checked}=event;
      this.showPowertrain=checked;
      if(this.showPowertrain === true) this.listLayoutOn = false;
      if(checked) {
        this.fetchPowertrainsForClient();
        this.fetchPiezoAssetsForClient()
      }
    }

    fetchPowertrainsForClient(){
      // this.powertrainList=[]
      this.powertrainLoader=true;
      this.service.getData(this.powertrainGetUrl + this.userID)
      // this.service.getData('http://localhost:7777/powertrain//powertrains/'+ this.clientId)
      .then(res => {
        this.powertrainLoader=false;
        let response = JSON.parse(JSON.stringify(res));
        if(response.code==200){
           this.powertrainList = response.body.filter(powertrain=>powertrain.subsystem_type=='powertrain').map(powertrain=>{
             let parsedSensors=JSON.parse(powertrain.device_position)
            return {...powertrain,sensors:JSON.parse(powertrain.device_position)}
          })
          this.powertrainAssetList= response.body.filter(powertrain=>powertrain.subsystem_type=='asset').map(powertrain=>{
            powertrain.device_position = JSON.parse(powertrain.device_position)
            return powertrain
          })
          // this.powertrainList=this.powertrainList.sort((a,b)=>{
          //   const order={h:0,v:1}
          //   // return order[a['orientation']]-order[b['orientation']]

          //   return a.subsystem_name.localeCompare(b.subsystem_name);
          // })

          const sortedDevices = this.powertrainList.sort((a:any, b:any) => {
            const extractStandNumber = (name: string) => {
              const match = name.match(/^STAND (\d+)/);
              return match ? parseInt(match[1], 10) : null;
            };

            const numA = extractStandNumber(a.subsystem_name);
            const numB = extractStandNumber(b.subsystem_name);

            // Sort non-stand items first
            if (numA === null && numB === null) return a.subsystem_name.localeCompare(b);
            if (numA === null) return 1;
            if (numB === null) return -1;

            // Sort by STAND number
            if (numA !== numB) return numA - numB;

            // Sort MOTOR & GEAR and ORTHO variants correctly
            return a.subsystem_name.localeCompare(b.subsystem_name);
          });
          // this.powertrainList=sortedDevices
        }


      })
       .catch(error => {
        //  console.log(error);
        }).finally(()=>{
          this.powertrainLoader=false;
        })
    }

    private detailWindowCount = Number(localStorage.getItem('detailWindowCount') || 0);
    openPowertrainScreen(index){
      let selectedPowertrain=this.powertrainList[index];
      let selectedSystem=this.allDeviceSecondArray.filter(asset=>asset.group_id==selectedPowertrain.subsystem_uuid)

      localStorage.setItem('SiteName', selectedSystem[0].site.name);
      localStorage.setItem('ApplicationName', selectedSystem[0].application.name);

      let params={
        skipLocationChange: true,
        queryParams:{
          subsystem_id:selectedPowertrain.id,
        client_id:selectedPowertrain.client_id,
        subsystem_name:selectedPowertrain.subsystem_name,
        site_id:selectedPowertrain.site_id,
        application_id:selectedPowertrain.application_id,
        oldDashboardParams:JSON.stringify(selectedSystem),
        uuid: selectedPowertrain.subsystem_uuid,
        overall_live_status:selectedPowertrain.overall_live_status
        }
      }
      console.log(params,'params=====')
      if (this.userID == '9000' || this.clientId == '9000') {
        const flags = new URLSearchParams({
          Monitoring_window: 'true',
          Powertrain_window: 'true'
        }).toString();

        const windowName = `detailWindow-${Date.now()}`;
        const childWin = window.open(`/#/detail-nxt-v2?${flags}`, windowName);

        if (!childWin) {
          console.error('Popup blocked');
          return;
        }

        const onReady = (e: MessageEvent) => {
          if (e.origin === window.location.origin && e.data?.type === 'ready') {
            childWin.postMessage(
              { type: 'init', payload: { data: params } },
              window.location.origin
            );
            window.removeEventListener('message', onReady);
          }
        };

        window.addEventListener('message', onReady, false);
      } else{
        this.router.navigate(['detail-nxt-v2'], params);
      }
    }

    checkIfPowertrainAssetsExists(){
      this.allDeviceSecondArray.map(asset=>{
         if(asset.powertrain==1){
            this.powertrainAsset++;
         }else{
          this.nonPowertrainAsset++;
         }
      })
      if(this.powertrainAsset>0 && this.nonPowertrainAsset==0){
        this.onPowertrainToggleChange({checked:true})
      }


    }
    showTooltip(sensor: any): string {
      return `
      Sensor:${sensor.assetType}
      Mac:${sensor.mac_address}
      Sr.No:${sensor.motor_serial}
      Name:${sensor.sensorMarker}
      `;
    }

    checkPowertrainStatus(){
    Promise.all([
      this.service.getDataV2(`${this.baseURL}get-software-products?client_id=${this.userID}`),
    ])
    .then(([resWithClient]: any[]) => {
      console.log(resWithClient)
      let client_software=[];
      if (resWithClient.data.code == '200' && resWithClient.data.status == 'success') {
        let {body,selected_ids} = resWithClient.data.body;
            console.log(body)
            console.log(selected_ids)
            let powertrain_id=body.res.filter(sft=>sft.key=='powertrain')[0].id
            console.log("PT ID:"+powertrain_id)
        if(powertrain_id && selected_ids.includes(powertrain_id)){
          this.isPowertrainEnabled=true;
        }
      }
    }).catch(err=>{
      this.isPowertrainEnabled=false;
    })
  }
  //------------------------------------------- POWERRTRAIN ENDS--------------------------------------

  // =======================================================================================================================================
    // =======================================================================================================================================
    // --------------------------------------------------------------PIEZO POWERTRAINS--------------------------------------------------------
    // =======================================================================================================================================
    // =======================================================================================================================================

    piezo_asset_list: Asset[] = [];
    filtered_piezo_asset_list: Asset[] = [];
    piezo_asset_loader: boolean = false;
    // url_prefix='https://qaapi.enertics.ca/piezo_service';
    // url_prefix='http://localhost:3017';
    url_prefix=BaseUrlConstantsService.BASE_PIEZO_SERVICE
    openMenuIndex: number | null = null;

      fetchPiezoAssetsForClient(): void {
      this.piezo_asset_loader = true;
      this.service.getDataV2(`${this.url_prefix}/api/get-subsystems/${this.userID}`)
        .then(res => {
          this.piezo_asset_loader = false;
          const response = JSON.parse(JSON.stringify(res));
          if (response.code === 200) {
            this.processPiezoAssetData(response);
          }
        })
        .catch(error => {
          console.error('Error fetching assets:', error);
          this.piezo_asset_loader = false;
        });

    }

    processPiezoAssetData(response: any): void {
      this.piezo_asset_list = response.data.map((asset: Asset) => {
        let parsedSensors: Sensor[] = [];
        try {
          parsedSensors = JSON.parse(asset.device_position);
          // Assign random colors and statuses for demo purposes
          parsedSensors = parsedSensors.map(sensor => ({
            ...sensor,
            color: sensor.color,
            asset_status: sensor.device_status
          }));
        } catch (error) {
          console.error('Error parsing device_position:', error);
        }
        return {
          ...asset,
          sensors: parsedSensors,
          overall_health: asset.overall_health,
          overall_live_status: asset.overall_live_status
        };
      });
      console.log(this.piezo_asset_list)

      this.filtered_piezo_asset_list = [...this.piezo_asset_list];
    }

    getRandomPiezoColor(): string {
      const colors = ['gray', 'gray', 'gray'];
      return colors[Math.floor(Math.random() * colors.length)];
    }

    togglePiezoMenu(event: Event, index: number): void {
      event.stopPropagation();
      this.openMenuIndex = this.openMenuIndex === index ? null : index;
    }

    closePiezoMenu(): void {
      this.openMenuIndex = null;
    }

    editPiezoAsset(event: Event, asset: Asset, index: number): void {
      event.stopPropagation();
      this.closePiezoMenu();
      this.router.navigate(['/piezeo-edit', asset]);
    }

    deletePiezoAsset(event: Event, asset: Asset, index: number): void {
      event.stopPropagation();
      this.closePiezoMenu();

      if (confirm(`Are you sure you want to delete "${asset.subsystem_name}"?`)) {
        this.piezo_asset_loader = true;
        this.service.deleteInfo(`${this.url_prefix}/api/delete-subsystem/${asset.id}/${this.userID}`)
        .then(res => {
          this.piezo_asset_loader = false;
          const response = JSON.parse(JSON.stringify(res));
          if (response.code === 200 || response.status === 'success') {
            // Remove asset from lists
            this.piezo_asset_list = this.piezo_asset_list.filter(a => a.id !== asset.id);
            this.filtered_piezo_asset_list = this.filtered_piezo_asset_list.filter(a => a.id !== asset.id);
            this.service.showSuccess('Asset deleted successfully');
          } else {
              this.service.showError('Failed to delete asset');
            }
          })
          .catch(error => {
            console.error('Error deleting asset:', error);
            this.piezo_asset_loader = false;
            alert('Error deleting asset. Please try again.');
          });
        }
    }

    openPiezoAssetDetails(index: number): void {
      this.router.navigate(['/piezo-dashboard', this.filtered_piezo_asset_list[index]]);
    }

    showPiezoTooltip(sensor: Sensor): string {
      const {subType,sensorDNames,assetType,gateway_id,master_type,mac_address:mac,serial_number:serial}=sensor;
      let sub_type=assetType=='MOTOR'?`Sub-Type: ${subType}`:'';
      let type=`Type: ${assetType}`;
      let display_name=`Sensor: ${sensorDNames}`
      let marker=`Marker: ${sensor.assetMarker}`
      let master__type=master_type==4?`Master-Type: Piezo`:master_type==3?`Master-Type: EmStd + RTDs`:master_type==2?`Master-Type: Em-Standard`:'Master-Type: Em-Mini';
      let mac_address=`MAC: ${mac}`
      let serial_number=`Serial: ${serial}`
      return `
        ${display_name}
        ${type}
        ${sub_type}
        ${marker}
        ${master__type}
        ${mac_address}
        ${serial_number}

      `;
    }

    getPiezoStatusLabel(status: number|string): string {
      switch (status) {
        case '0':
        case '2':
          return 'Asset Idle';
        case '1':
          return 'Asset Running';
        default:
          return 'Unknown';
      }
    }

    getPiezoStatusColor(status: string): string {
      switch (status) {
        case '0':
        case '2':
          return '#dbccbf';
        case '1':
          return '#3fbddd';
        default:
          return '#999';
      }
    }

}
